(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/**
 *  lithtml
 */ /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0585bced692c3b45$var$t = globalThis, $0585bced692c3b45$var$i = $0585bced692c3b45$var$t.trustedTypes, $0585bced692c3b45$var$s = $0585bced692c3b45$var$i ? $0585bced692c3b45$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $0585bced692c3b45$var$e = "$lit$", $0585bced692c3b45$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $0585bced692c3b45$var$o = "?" + $0585bced692c3b45$var$h, $0585bced692c3b45$var$n = `<${$0585bced692c3b45$var$o}>`, $0585bced692c3b45$var$r = document, $0585bced692c3b45$var$l = ()=>$0585bced692c3b45$var$r.createComment(""), $0585bced692c3b45$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $0585bced692c3b45$var$a = Array.isArray, $0585bced692c3b45$var$u = (t)=>$0585bced692c3b45$var$a(t) || "function" == typeof t?.[Symbol.iterator], $0585bced692c3b45$var$d = "[ \t\n\f\r]", $0585bced692c3b45$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $0585bced692c3b45$var$v = /-->/g, $0585bced692c3b45$var$_ = />/g, $0585bced692c3b45$var$m = RegExp(`>|${$0585bced692c3b45$var$d}(?:([^\\s"'>=/]+)(${$0585bced692c3b45$var$d}*=${$0585bced692c3b45$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $0585bced692c3b45$var$p = /'/g, $0585bced692c3b45$var$g = /"/g, $0585bced692c3b45$var$$ = /^(?:script|style|textarea|title)$/i, $0585bced692c3b45$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $0585bced692c3b45$export$c0bb0b647f701bb5 = $0585bced692c3b45$var$y(1), $0585bced692c3b45$export$7ed1367e7fa1ad68 = $0585bced692c3b45$var$y(2), $0585bced692c3b45$export$47d5b44d225be5b4 = $0585bced692c3b45$var$y(3), $0585bced692c3b45$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $0585bced692c3b45$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $0585bced692c3b45$var$A = new WeakMap, $0585bced692c3b45$var$C = $0585bced692c3b45$var$r.createTreeWalker($0585bced692c3b45$var$r, 129);
function $0585bced692c3b45$var$P(t, i) {
    if (!$0585bced692c3b45$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $0585bced692c3b45$var$s ? $0585bced692c3b45$var$s.createHTML(i) : i;
}
const $0585bced692c3b45$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $0585bced692c3b45$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $0585bced692c3b45$var$f ? "!--" === u[1] ? c = $0585bced692c3b45$var$v : void 0 !== u[1] ? c = $0585bced692c3b45$var$_ : void 0 !== u[2] ? ($0585bced692c3b45$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $0585bced692c3b45$var$m) : void 0 !== u[3] && (c = $0585bced692c3b45$var$m) : c === $0585bced692c3b45$var$m ? ">" === u[0] ? (c = r ?? $0585bced692c3b45$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $0585bced692c3b45$var$m : '"' === u[3] ? $0585bced692c3b45$var$g : $0585bced692c3b45$var$p) : c === $0585bced692c3b45$var$g || c === $0585bced692c3b45$var$p ? c = $0585bced692c3b45$var$m : c === $0585bced692c3b45$var$v || c === $0585bced692c3b45$var$_ ? c = $0585bced692c3b45$var$f : (c = $0585bced692c3b45$var$m, r = void 0);
        const x = c === $0585bced692c3b45$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $0585bced692c3b45$var$f ? s + $0585bced692c3b45$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $0585bced692c3b45$var$e + s.slice(d) + $0585bced692c3b45$var$h + x) : s + $0585bced692c3b45$var$h + (-2 === d ? i : x);
    }
    return [
        $0585bced692c3b45$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $0585bced692c3b45$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $0585bced692c3b45$var$V(t, s);
        if (this.el = $0585bced692c3b45$var$N.createElement(f, n), $0585bced692c3b45$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $0585bced692c3b45$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($0585bced692c3b45$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($0585bced692c3b45$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $0585bced692c3b45$var$H : "?" === e[1] ? $0585bced692c3b45$var$I : "@" === e[1] ? $0585bced692c3b45$var$L : $0585bced692c3b45$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($0585bced692c3b45$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($0585bced692c3b45$var$$.test(r.tagName)) {
                    const t = r.textContent.split($0585bced692c3b45$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $0585bced692c3b45$var$i ? $0585bced692c3b45$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $0585bced692c3b45$var$l()), $0585bced692c3b45$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $0585bced692c3b45$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $0585bced692c3b45$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($0585bced692c3b45$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $0585bced692c3b45$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $0585bced692c3b45$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $0585bced692c3b45$var$S(t, i, s = t, e) {
    if (i === $0585bced692c3b45$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $0585bced692c3b45$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $0585bced692c3b45$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $0585bced692c3b45$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $0585bced692c3b45$var$r).importNode(i, !0);
        $0585bced692c3b45$var$C.currentNode = e;
        let h = $0585bced692c3b45$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $0585bced692c3b45$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $0585bced692c3b45$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $0585bced692c3b45$var$C.nextNode(), o++);
        }
        return $0585bced692c3b45$var$C.currentNode = $0585bced692c3b45$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $0585bced692c3b45$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $0585bced692c3b45$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $0585bced692c3b45$var$S(this, t, i), $0585bced692c3b45$var$c(t) ? t === $0585bced692c3b45$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $0585bced692c3b45$export$45b790e32b2810ee && this._$AR(), this._$AH = $0585bced692c3b45$export$45b790e32b2810ee) : t !== this._$AH && t !== $0585bced692c3b45$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $0585bced692c3b45$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $0585bced692c3b45$export$45b790e32b2810ee && $0585bced692c3b45$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($0585bced692c3b45$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $0585bced692c3b45$var$N.createElement($0585bced692c3b45$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $0585bced692c3b45$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $0585bced692c3b45$var$A.get(t.strings);
        return void 0 === i && $0585bced692c3b45$var$A.set(t.strings, i = new $0585bced692c3b45$var$N(t)), i;
    }
    k(t) {
        $0585bced692c3b45$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $0585bced692c3b45$var$R(this.O($0585bced692c3b45$var$l()), this.O($0585bced692c3b45$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $0585bced692c3b45$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $0585bced692c3b45$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $0585bced692c3b45$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $0585bced692c3b45$var$S(this, t, i, 0), o = !$0585bced692c3b45$var$c(t) || t !== this._$AH && t !== $0585bced692c3b45$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $0585bced692c3b45$var$S(this, e[s + n], i, n), r === $0585bced692c3b45$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$0585bced692c3b45$var$c(r) || r !== this._$AH[n], r === $0585bced692c3b45$export$45b790e32b2810ee ? t = $0585bced692c3b45$export$45b790e32b2810ee : t !== $0585bced692c3b45$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $0585bced692c3b45$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $0585bced692c3b45$var$H extends $0585bced692c3b45$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $0585bced692c3b45$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $0585bced692c3b45$var$I extends $0585bced692c3b45$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $0585bced692c3b45$export$45b790e32b2810ee);
    }
}
class $0585bced692c3b45$var$L extends $0585bced692c3b45$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $0585bced692c3b45$var$S(this, t, i, 0) ?? $0585bced692c3b45$export$45b790e32b2810ee) === $0585bced692c3b45$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $0585bced692c3b45$export$45b790e32b2810ee && s !== $0585bced692c3b45$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $0585bced692c3b45$export$45b790e32b2810ee && (s === $0585bced692c3b45$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $0585bced692c3b45$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $0585bced692c3b45$var$S(this, t);
    }
}
const $0585bced692c3b45$export$8613d1ca9052b22e = {
    M: $0585bced692c3b45$var$e,
    P: $0585bced692c3b45$var$h,
    A: $0585bced692c3b45$var$o,
    C: 1,
    L: $0585bced692c3b45$var$V,
    R: $0585bced692c3b45$var$M,
    D: $0585bced692c3b45$var$u,
    V: $0585bced692c3b45$var$S,
    I: $0585bced692c3b45$var$R,
    H: $0585bced692c3b45$var$k,
    N: $0585bced692c3b45$var$I,
    U: $0585bced692c3b45$var$L,
    B: $0585bced692c3b45$var$H,
    F: $0585bced692c3b45$var$z
}, $0585bced692c3b45$var$j = $0585bced692c3b45$var$t.litHtmlPolyfillSupport;
$0585bced692c3b45$var$j?.($0585bced692c3b45$var$N, $0585bced692c3b45$var$R), ($0585bced692c3b45$var$t.litHtmlVersions ??= []).push("3.3.1");
const $0585bced692c3b45$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $0585bced692c3b45$var$R(i.insertBefore($0585bced692c3b45$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4da6ecdff868c42e$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $4da6ecdff868c42e$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $4da6ecdff868c42e$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $8916f75be6085108$var$t } = (0, $0585bced692c3b45$export$8613d1ca9052b22e), $8916f75be6085108$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $8916f75be6085108$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $8916f75be6085108$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $8916f75be6085108$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $8916f75be6085108$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $8916f75be6085108$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $8916f75be6085108$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $8916f75be6085108$var$r = ()=>document.createComment(""), $8916f75be6085108$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($8916f75be6085108$var$r(), l), d = e.insertBefore($8916f75be6085108$var$r(), l);
        n = new $8916f75be6085108$var$t(i, d, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, d = i !== o;
        if (d) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || d) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $8916f75be6085108$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $8916f75be6085108$var$u = {}, $8916f75be6085108$export$ea70d9dd5965b1c8 = (o, t = $8916f75be6085108$var$u)=>o._$AH = t, $8916f75be6085108$export$59e9bce518cde500 = (o)=>o._$AH, $8916f75be6085108$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $8916f75be6085108$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2d06e2ab5b695b60$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $2d06e2ab5b695b60$export$76d90c956114f2c2 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(e){
        if (super(e), e.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    dt(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.dt(e, s, t).values;
    }
    update(s, [t, r, c]) {
        const d = (0, $8916f75be6085108$export$59e9bce518cde500)(s), { values: p, keys: a } = this.dt(t, r, c);
        if (!Array.isArray(d)) return this.ut = a, p;
        const h = this.ut ??= [], v = [];
        let m, y, x = 0, j = d.length - 1, k = 0, w = p.length - 1;
        for(; x <= j && k <= w;)if (null === d[x]) x++;
        else if (null === d[j]) j--;
        else if (h[x] === a[k]) v[k] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(d[x], p[k]), x++, k++;
        else if (h[j] === a[w]) v[w] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(d[j], p[w]), j--, w--;
        else if (h[x] === a[w]) v[w] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(d[x], p[w]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, v[w + 1], d[x]), x++, w--;
        else if (h[j] === a[k]) v[k] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(d[j], p[k]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, d[x], d[j]), j--, k++;
        else if (void 0 === m && (m = $2d06e2ab5b695b60$var$u(a, k, w), y = $2d06e2ab5b695b60$var$u(h, x, j)), m.has(h[x])) {
            if (m.has(h[j])) {
                const e = y.get(a[k]), t = void 0 !== e ? d[e] : null;
                if (null === t) {
                    const e = (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, d[x]);
                    (0, $8916f75be6085108$export$cb8bf9562088e9f4)(e, p[k]), v[k] = e;
                } else v[k] = (0, $8916f75be6085108$export$cb8bf9562088e9f4)(t, p[k]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, d[x], t), d[e] = null;
                k++;
            } else (0, $8916f75be6085108$export$3133b3144bbba267)(d[j]), j--;
        } else (0, $8916f75be6085108$export$3133b3144bbba267)(d[x]), x++;
        for(; k <= w;){
            const e = (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, v[w + 1]);
            (0, $8916f75be6085108$export$cb8bf9562088e9f4)(e, p[k]), v[k++] = e;
        }
        for(; x <= j;){
            const e = d[x++];
            null !== e && (0, $8916f75be6085108$export$3133b3144bbba267)(e);
        }
        return this.ut = a, (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(s, v), $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
});






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aa51d98594d61009$var$s = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $aa51d98594d61009$var$s(i, t);
    return !0;
}, $aa51d98594d61009$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $aa51d98594d61009$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $aa51d98594d61009$var$c(t);
    }
};
function $aa51d98594d61009$var$h(i) {
    void 0 !== this._$AN ? ($aa51d98594d61009$var$o(this), this._$AM = i, $aa51d98594d61009$var$r(this)) : this._$AM = i;
}
function $aa51d98594d61009$var$n(i, t = !1, e = 0) {
    const r = this._$AH, h = this._$AN;
    if (void 0 !== h && 0 !== h.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$aa51d98594d61009$var$s(r[i], !1), $aa51d98594d61009$var$o(r[i]);
            else null != r && ($aa51d98594d61009$var$s(r, !1), $aa51d98594d61009$var$o(r));
        } else $aa51d98594d61009$var$s(this, i);
    }
}
const $aa51d98594d61009$var$c = (i)=>{
    i.type == (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $aa51d98594d61009$var$n, i._$AQ ??= $aa51d98594d61009$var$h);
};
class $aa51d98594d61009$export$7d025501802325e extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $aa51d98594d61009$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($aa51d98594d61009$var$s(this, i), $aa51d98594d61009$var$o(this));
    }
    setValue(t) {
        if ((0, $8916f75be6085108$export$7f431ad0fff82fd9)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7a66d9d32f17f475$export$74673a32c6041f3e = async (t, s)=>{
    for await (const i of t)if (!1 === await s(i)) return;
};
class $7a66d9d32f17f475$export$71341b9b69479007 {
    constructor(t){
        this.G = t;
    }
    disconnect() {
        this.G = void 0;
    }
    reconnect(t) {
        this.G = t;
    }
    deref() {
        return this.G;
    }
}
class $7a66d9d32f17f475$export$193ea5a420bb5c41 {
    constructor(){
        this.Y = void 0, this.Z = void 0;
    }
    get() {
        return this.Y;
    }
    pause() {
        this.Y ??= new Promise((t)=>this.Z = t);
    }
    resume() {
        this.Z?.(), this.Y = this.Z = void 0;
    }
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $9a7b48e7039d5564$export$39a433aa22cdf479 extends (0, $aa51d98594d61009$export$7d025501802325e) {
    constructor(){
        super(...arguments), this._$CK = new (0, $7a66d9d32f17f475$export$71341b9b69479007)(this), this._$CX = new (0, $7a66d9d32f17f475$export$193ea5a420bb5c41);
    }
    render(i, s) {
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
    update(i, [s, r]) {
        if (this.isConnected || this.disconnected(), s === this._$CJ) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        this._$CJ = s;
        let n = 0;
        const { _$CK: o, _$CX: h } = this;
        return (0, $7a66d9d32f17f475$export$74673a32c6041f3e)(s, async (t)=>{
            for(; h.get();)await h.get();
            const i = o.deref();
            if (void 0 !== i) {
                if (i._$CJ !== s) return !1;
                void 0 !== r && (t = r(t, n)), i.commitValue(t, n), n++;
            }
            return !0;
        }), $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
    commitValue(t, i) {
        this.setValue(t);
    }
    disconnected() {
        this._$CK.disconnect(), this._$CX.pause();
    }
    reconnected() {
        this._$CK.reconnect(this), this._$CX.resume();
    }
}
const $9a7b48e7039d5564$export$662eef59ff6bd56a = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($9a7b48e7039d5564$export$39a433aa22cdf479);



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $82e12a832c7dc237$export$eaa89ade56b7c0c1 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $9a7b48e7039d5564$export$39a433aa22cdf479) {
    constructor(r){
        if (super(r), r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error("asyncAppend can only be used in child expressions");
    }
    update(r, e) {
        return this._$Ctt = r, super.update(r, e);
    }
    commitValue(r, e) {
        0 === e && (0, $8916f75be6085108$export$7f600b8138c094dc)(this._$Ctt);
        const s = (0, $8916f75be6085108$export$291b2338ad9b0b30)(this._$Ctt);
        (0, $8916f75be6085108$export$cb8bf9562088e9f4)(s, r);
    }
});






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $77f5167d06bc2fde$var$d = (t)=>(0, $8916f75be6085108$export$6a0e8de894d2fcca)(t) ? t._$litType$.h : t.strings, $77f5167d06bc2fde$export$69a3209f1a06c04d = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        super(t), this.et = new WeakMap;
    }
    render(t) {
        return [
            t
        ];
    }
    update(s, [e]) {
        const u = (0, $8916f75be6085108$export$6b6d145ec2a44ca9)(this.it) ? $77f5167d06bc2fde$var$d(this.it) : null, h = (0, $8916f75be6085108$export$6b6d145ec2a44ca9)(e) ? $77f5167d06bc2fde$var$d(e) : null;
        if (null !== u && (null === h || u !== h)) {
            const e = (0, $8916f75be6085108$export$59e9bce518cde500)(s).pop();
            let o = this.et.get(u);
            if (void 0 === o) {
                const s = document.createDocumentFragment();
                o = (0, $0585bced692c3b45$export$b3890eb0ae9dca99)((0, $0585bced692c3b45$export$45b790e32b2810ee), s), o.setConnected(!1), this.et.set(u, o);
            }
            (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(o, [
                e
            ]), (0, $8916f75be6085108$export$291b2338ad9b0b30)(o, void 0, e);
        }
        if (null !== h) {
            if (null === u || u !== h) {
                const t = this.et.get(h);
                if (void 0 !== t) {
                    const i = (0, $8916f75be6085108$export$59e9bce518cde500)(t).pop();
                    (0, $8916f75be6085108$export$7f600b8138c094dc)(s), (0, $8916f75be6085108$export$291b2338ad9b0b30)(s, void 0, i), (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(s, [
                        i
                    ]);
                }
            }
            this.it = e;
        } else this.it = void 0;
        return this.render(e);
    }
});




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e4437dd0216a4379$export$56cc687933817664 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
});




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0100bfbf2c1b33f3$var$e = {}, $0100bfbf2c1b33f3$export$864d727b48066337 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this.ot = $0100bfbf2c1b33f3$var$e;
    }
    render(r, t) {
        return t();
    }
    update(t, [s, e]) {
        if (Array.isArray(s)) {
            if (Array.isArray(this.ot) && this.ot.length === s.length && s.every((r, t)=>r === this.ot[t])) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        } else if (this.ot === s) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        return this.ot = Array.isArray(s) ? Array.from(s) : s, this.render(s, e);
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2ed4c26e5fc1311e$export$28cf49ad70f82d12 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(r){
        if (super(r), r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).PROPERTY && r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE && r.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $8916f75be6085108$export$7f431ad0fff82fd9)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $0585bced692c3b45$export$9c068ae9cc5db4e8) || t === (0, $0585bced692c3b45$export$45b790e32b2810ee)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).PROPERTY) {
            if (t === o[l]) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        } else if (i.type === (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
        return (0, $8916f75be6085108$export$ea70d9dd5965b1c8)(i), t;
    }
});





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $65d76be7707749f6$export$7d1e3a5e95ceca43 = ()=>new $65d76be7707749f6$var$h;
class $65d76be7707749f6$var$h {
}
const $65d76be7707749f6$var$o = new WeakMap, $65d76be7707749f6$export$eff4d24c3ff7876e = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $aa51d98594d61009$export$7d025501802325e) {
    render(i) {
        return 0, $0585bced692c3b45$export$45b790e32b2810ee;
    }
    update(i, [s]) {
        const e = s !== this.G;
        return e && void 0 !== this.G && this.rt(void 0), (e || this.lt !== this.ct) && (this.G = s, this.ht = i.options?.host, this.rt(this.ct = i.element)), $0585bced692c3b45$export$45b790e32b2810ee;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.G) {
            const i = this.ht ?? globalThis;
            let s = $65d76be7707749f6$var$o.get(i);
            void 0 === s && (s = new WeakMap, $65d76be7707749f6$var$o.set(i, s)), void 0 !== s.get(this.G) && this.G.call(this.ht, void 0), s.set(this.G, t), void 0 !== t && this.G.call(this.ht, t);
        } else this.G.value = t;
    }
    get lt() {
        return "function" == typeof this.G ? $65d76be7707749f6$var$o.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $22f699b0009eb85b$var$n = "important", $22f699b0009eb85b$var$i = " !" + $22f699b0009eb85b$var$n, $22f699b0009eb85b$export$1e5b4ce2fa884e6a = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || t.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ft) return this.ft = new Set(Object.keys(r)), this.render(r);
        for (const t of this.ft)null == r[t] && (this.ft.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = null);
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ft.add(t);
                const r = "string" == typeof e && e.endsWith($22f699b0009eb85b$var$i);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $22f699b0009eb85b$var$n : "") : s[t] = e;
            }
        }
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
});




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9a609a3f11152775$export$e446d0492332fcd4 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error("templateContent can only be used in child bindings");
    }
    render(r) {
        return this.vt === r ? (0, $0585bced692c3b45$export$9c068ae9cc5db4e8) : (this.vt = r, document.importNode(r.content, !0));
    }
});




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $0a9d83bb2173ec99$export$3bebd1f0e3943985 extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(i){
        if (super(i), this.it = (0, $0585bced692c3b45$export$45b790e32b2810ee), i.type !== (0, $4da6ecdff868c42e$export$9ba3b3f20a85bfa).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
    render(r) {
        if (r === (0, $0585bced692c3b45$export$45b790e32b2810ee) || null == r) return this._t = void 0, this.it = r;
        if (r === (0, $0585bced692c3b45$export$9c068ae9cc5db4e8)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.it) return this._t;
        this.it = r;
        const s = [
            r
        ];
        return s.raw = s, this._t = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
}
$0a9d83bb2173ec99$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $0a9d83bb2173ec99$export$3bebd1f0e3943985.resultType = 1;
const $0a9d83bb2173ec99$export$b6e69390c23686fb = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($0a9d83bb2173ec99$export$3bebd1f0e3943985);




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $378ddd6808e465bc$var$t extends (0, $0a9d83bb2173ec99$export$3bebd1f0e3943985) {
}
$378ddd6808e465bc$var$t.directiveName = "unsafeSVG", $378ddd6808e465bc$var$t.resultType = 2;
const $378ddd6808e465bc$export$1cb98903879b8bf5 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($378ddd6808e465bc$var$t);







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $04babc6848c3c9b3$var$n = (t)=>!(0, $8916f75be6085108$export$c3825b437cbdea5c)(t) && "function" == typeof t.then, $04babc6848c3c9b3$var$h = 1073741823;
class $04babc6848c3c9b3$export$51c6edf8ee19b71a extends (0, $aa51d98594d61009$export$7d025501802325e) {
    constructor(){
        super(...arguments), this._$Cwt = $04babc6848c3c9b3$var$h, this._$Cbt = [], this._$CK = new (0, $7a66d9d32f17f475$export$71341b9b69479007)(this), this._$CX = new (0, $7a66d9d32f17f475$export$193ea5a420bb5c41);
    }
    render(...s) {
        return s.find((t)=>!$04babc6848c3c9b3$var$n(t)) ?? (0, $0585bced692c3b45$export$9c068ae9cc5db4e8);
    }
    update(s, i) {
        const e = this._$Cbt;
        let r = e.length;
        this._$Cbt = i;
        const o = this._$CK, c = this._$CX;
        this.isConnected || this.disconnected();
        for(let t = 0; t < i.length && !(t > this._$Cwt); t++){
            const s = i[t];
            if (!$04babc6848c3c9b3$var$n(s)) return this._$Cwt = t, s;
            t < r && s === e[t] || (this._$Cwt = $04babc6848c3c9b3$var$h, r = 0, Promise.resolve(s).then(async (t)=>{
                for(; c.get();)await c.get();
                const i = o.deref();
                if (void 0 !== i) {
                    const e = i._$Cbt.indexOf(s);
                    e > -1 && e < i._$Cwt && (i._$Cwt = e, i.setValue(t));
                }
            }));
        }
        return 0, $0585bced692c3b45$export$9c068ae9cc5db4e8;
    }
    disconnected() {
        this._$CK.disconnect(), this._$CX.pause();
    }
    reconnected() {
        this._$CK.reconnect(this), this._$CX.resume();
    }
}
const $04babc6848c3c9b3$export$a40009bd2c363351 = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)($04babc6848c3c9b3$export$51c6edf8ee19b71a);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7b7b9a37160c97db$export$7877a478dd30fd3d = (r, o, t)=>{
    for (const t of o)if (t[0] === r) return (0, t[1])();
    return t?.();
};



/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $49f9812d6d4b3bb6$export$f68dd208b5df064d = (o)=>o ?? (0, $0585bced692c3b45$export$45b790e32b2810ee);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $0d7955f0662edf92$export$f7e2c8231c57a8bd(o, t) {
    const f = "function" == typeof t;
    if (void 0 !== o) {
        let i = -1;
        for (const n of o)i > -1 && (yield f ? t(i) : t), i++, yield n;
    }
}





/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ef64bd03c02e190d$export$8dbf9c790527241e = (0, $4da6ecdff868c42e$export$99b43ad1ed32e735)(class extends (0, $4da6ecdff868c42e$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this.key = (0, $0585bced692c3b45$export$45b790e32b2810ee);
    }
    render(r, t) {
        return this.key = r, t;
    }
    update(r, [t, e]) {
        return t !== this.key && ((0, $8916f75be6085108$export$ea70d9dd5965b1c8)(r), this.key = t), e;
    }
});


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $efb58c27b85b03fa$export$871de8747c9eaa88(o, f) {
    if (void 0 !== o) {
        let i = 0;
        for (const t of o)yield f(t, i++);
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $b0f47510656516d3$export$d02631cccf789723(o1, t, e = 1) {
    const i = void 0 === t ? 0 : o1;
    t ??= o1;
    for(let o = i; e > 0 ? o < t : t < o; o += e)yield o;
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d2deeaf9cd169c53$export$a55877ca9db47377(n, r, t) {
    return n ? r(n) : t?.(n);
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $ada89af8a6b41f40$export$f137a505d4546509 {
    constructor(config){
        this._map = new Map();
        this._roundAverageSize = false;
        this.totalSize = 0;
        if (config?.roundAverageSize === true) this._roundAverageSize = true;
    }
    set(index, value) {
        const prev = this._map.get(index) || 0;
        this._map.set(index, value);
        this.totalSize += value - prev;
    }
    get averageSize() {
        if (this._map.size > 0) {
            const average = this.totalSize / this._map.size;
            return this._roundAverageSize ? Math.round(average) : average;
        }
        return 0;
    }
    getSize(index) {
        return this._map.get(index);
    }
    clear() {
        this._map.clear();
        this.totalSize = 0;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $da15e1c70bd0293d$export$29850d3944833d4a(direction) {
    return direction === 'horizontal' ? 'width' : 'height';
}
function $da15e1c70bd0293d$export$a1d125f9318aba81(direction) {
    return direction === 'horizontal' ? 'height' : 'width';
}
function $da15e1c70bd0293d$export$cdeb9fdc4acba46a(direction) {
    return direction === 'horizontal' ? 'left' : 'top';
}
function $da15e1c70bd0293d$export$78f529f5595f2e2d(direction) {
    return direction === 'horizontal' ? 'top' : 'left';
}
class $da15e1c70bd0293d$export$64943d2e59d72a29 {
    _getDefaultConfig() {
        return {
            direction: 'vertical'
        };
    }
    constructor(hostSink, config){
        /**
         * The last set viewport scroll position.
         */ this._latestCoords = {
            left: 0,
            top: 0
        };
        /**
         * Scrolling direction.
         */ this._direction = null;
        /**
         * Dimensions of the viewport.
         */ this._viewportSize = {
            width: 0,
            height: 0
        };
        this.totalScrollSize = {
            width: 0,
            height: 0
        };
        this.offsetWithinScroller = {
            left: 0,
            top: 0
        };
        /**
         * Flag for debouncing asynchronous reflow requests.
         */ this._pendingReflow = false;
        this._pendingLayoutUpdate = false;
        this._pin = null;
        /**
         * The index of the first item intersecting the viewport.
         */ this._firstVisible = 0;
        /**
         * The index of the last item intersecting the viewport.
         */ this._lastVisible = 0;
        /**
         * Pixel offset in the scroll direction of the first child.
         */ this._physicalMin = 0;
        /**
         * Pixel offset in the scroll direction of the last child.
         */ this._physicalMax = 0;
        /**
         * Index of the first child.
         */ this._first = -1;
        /**
         * Index of the last child.
         */ this._last = -1;
        /**
         * Length in the scrolling direction.
         */ this._sizeDim = 'height';
        /**
         * Length in the non-scrolling direction.
         */ this._secondarySizeDim = 'width';
        /**
         * Position in the scrolling direction.
         */ this._positionDim = 'top';
        /**
         * Position in the non-scrolling direction.
         */ this._secondaryPositionDim = 'left';
        /**
         * Current scroll offset in pixels.
         */ this._scrollPosition = 0;
        /**
         * Difference between current scroll offset and scroll offset calculated due
         * to a reflow.
         */ this._scrollError = 0;
        /**
         * Total number of items that could possibly be displayed. Used to help
         * calculate the scroll size.
         */ this._items = [];
        /**
         * The total (estimated) length of all items in the scrolling direction.
         */ this._scrollSize = 1;
        /**
         * Number of pixels beyond the viewport to still include
         * in the active range of items.
         */ // TODO (graynorton): Probably want to make this something we calculate based
        // on viewport size, item size, other factors, possibly still with a dial of some kind
        this._overhang = 1000;
        this._hostSink = hostSink;
        // Delay setting config so that subclasses do setup work first
        Promise.resolve().then(()=>this.config = config || this._getDefaultConfig());
    }
    set config(config) {
        Object.assign(this, Object.assign({}, this._getDefaultConfig(), config));
    }
    get config() {
        return {
            direction: this.direction
        };
    }
    /**
     * Maximum index of children + 1, to help estimate total height of the scroll
     * space.
     */ get items() {
        return this._items;
    }
    set items(items) {
        this._setItems(items);
    }
    _setItems(items) {
        if (items !== this._items) {
            this._items = items;
            this._scheduleReflow();
        }
    }
    /**
     * Primary scrolling direction.
     */ get direction() {
        return this._direction;
    }
    set direction(dir) {
        // Force it to be either horizontal or vertical.
        dir = dir === 'horizontal' ? dir : 'vertical';
        if (dir !== this._direction) {
            this._direction = dir;
            this._sizeDim = dir === 'horizontal' ? 'width' : 'height';
            this._secondarySizeDim = dir === 'horizontal' ? 'height' : 'width';
            this._positionDim = dir === 'horizontal' ? 'left' : 'top';
            this._secondaryPositionDim = dir === 'horizontal' ? 'top' : 'left';
            this._triggerReflow();
        }
    }
    /**
     * Height and width of the viewport.
     */ get viewportSize() {
        return this._viewportSize;
    }
    set viewportSize(dims) {
        const { _viewDim1: _viewDim1, _viewDim2: _viewDim2 } = this;
        Object.assign(this._viewportSize, dims);
        if (_viewDim2 !== this._viewDim2) // this._viewDim2Changed();
        this._scheduleLayoutUpdate();
        else if (_viewDim1 !== this._viewDim1) this._checkThresholds();
    }
    /**
     * Scroll offset of the viewport.
     */ get viewportScroll() {
        return this._latestCoords;
    }
    set viewportScroll(coords) {
        Object.assign(this._latestCoords, coords);
        const oldPos = this._scrollPosition;
        this._scrollPosition = this._latestCoords[this._positionDim];
        const change = Math.abs(oldPos - this._scrollPosition);
        if (change >= 1) this._checkThresholds();
    }
    /**
     * Perform a reflow if one has been scheduled.
     */ reflowIfNeeded(force = false) {
        if (force || this._pendingReflow) {
            this._pendingReflow = false;
            this._reflow();
        }
    }
    set pin(options) {
        this._pin = options;
        this._triggerReflow();
    }
    get pin() {
        if (this._pin !== null) {
            const { index: index, block: block } = this._pin;
            return {
                index: Math.max(0, Math.min(index, this.items.length - 1)),
                block: block
            };
        }
        return null;
    }
    _clampScrollPosition(val) {
        return Math.max(-this.offsetWithinScroller[this._positionDim], Math.min(val, this.totalScrollSize[$da15e1c70bd0293d$export$29850d3944833d4a(this.direction)] - this._viewDim1));
    }
    unpin() {
        if (this._pin !== null) {
            this._sendUnpinnedMessage();
            this._pin = null;
        }
    }
    _updateLayout() {
    // Override
    }
    // protected _viewDim2Changed(): void {
    //   this._scheduleLayoutUpdate();
    // }
    /**
     * The height or width of the viewport, whichever corresponds to the scrolling direction.
     */ get _viewDim1() {
        return this._viewportSize[this._sizeDim];
    }
    /**
     * The height or width of the viewport, whichever does NOT correspond to the scrolling direction.
     */ get _viewDim2() {
        return this._viewportSize[this._secondarySizeDim];
    }
    _scheduleReflow() {
        this._pendingReflow = true;
    }
    _scheduleLayoutUpdate() {
        this._pendingLayoutUpdate = true;
        this._scheduleReflow();
    }
    // For triggering a reflow based on incoming changes to
    // the layout config.
    _triggerReflow() {
        this._scheduleLayoutUpdate();
        // TODO graynorton@: reflowIfNeeded() isn't really supposed
        // to be called internally. Address in larger cleanup
        // of virtualizer / layout interaction pattern.
        // this.reflowIfNeeded(true);
        Promise.resolve().then(()=>this.reflowIfNeeded());
    }
    _reflow() {
        if (this._pendingLayoutUpdate) {
            this._updateLayout();
            this._pendingLayoutUpdate = false;
        }
        this._updateScrollSize();
        this._setPositionFromPin();
        this._getActiveItems();
        this._updateVisibleIndices();
        this._sendStateChangedMessage();
    }
    /**
     * If we are supposed to be pinned to a particular
     * item or set of coordinates, we set `_scrollPosition`
     * accordingly and adjust `_scrollError` as needed
     * so that the virtualizer can keep the scroll
     * position in the DOM in sync
     */ _setPositionFromPin() {
        if (this.pin !== null) {
            const lastScrollPosition = this._scrollPosition;
            const { index: index, block: block } = this.pin;
            this._scrollPosition = this._calculateScrollIntoViewPosition({
                index: index,
                block: block || 'start'
            }) - this.offsetWithinScroller[this._positionDim];
            this._scrollError = lastScrollPosition - this._scrollPosition;
        }
    }
    /**
     * Calculate the coordinates to scroll to, given
     * a request to scroll to the element at a specific
     * index.
     *
     * Supports the same positioning options (`start`,
     * `center`, `end`, `nearest`) as the standard
     * `Element.scrollIntoView()` method, but currently
     * only considers the provided value in the `block`
     * dimension, since we don't yet have any layouts
     * that support virtualization in two dimensions.
     */ _calculateScrollIntoViewPosition(options) {
        const { block: block } = options;
        const index = Math.min(this.items.length, Math.max(0, options.index));
        const itemStartPosition = this._getItemPosition(index)[this._positionDim];
        let scrollPosition = itemStartPosition;
        if (block !== 'start') {
            const itemSize = this._getItemSize(index)[this._sizeDim];
            if (block === 'center') scrollPosition = itemStartPosition - 0.5 * this._viewDim1 + 0.5 * itemSize;
            else {
                const itemEndPosition = itemStartPosition - this._viewDim1 + itemSize;
                if (block === 'end') scrollPosition = itemEndPosition;
                else {
                    // block === 'nearest'
                    const currentScrollPosition = this._scrollPosition;
                    scrollPosition = Math.abs(currentScrollPosition - itemStartPosition) < Math.abs(currentScrollPosition - itemEndPosition) ? itemStartPosition : itemEndPosition;
                }
            }
        }
        scrollPosition += this.offsetWithinScroller[this._positionDim];
        return this._clampScrollPosition(scrollPosition);
    }
    getScrollIntoViewCoordinates(options) {
        return {
            [this._positionDim]: this._calculateScrollIntoViewPosition(options)
        };
    }
    _sendUnpinnedMessage() {
        this._hostSink({
            type: 'unpinned'
        });
    }
    _sendVisibilityChangedMessage() {
        this._hostSink({
            type: 'visibilityChanged',
            firstVisible: this._firstVisible,
            lastVisible: this._lastVisible
        });
    }
    _sendStateChangedMessage() {
        const childPositions = new Map();
        if (this._first !== -1 && this._last !== -1) for(let idx = this._first; idx <= this._last; idx++)childPositions.set(idx, this._getItemPosition(idx));
        const message = {
            type: 'stateChanged',
            scrollSize: {
                [this._sizeDim]: this._scrollSize,
                [this._secondarySizeDim]: null
            },
            range: {
                first: this._first,
                last: this._last,
                firstVisible: this._firstVisible,
                lastVisible: this._lastVisible
            },
            childPositions: childPositions
        };
        if (this._scrollError) {
            message.scrollError = {
                [this._positionDim]: this._scrollError,
                [this._secondaryPositionDim]: 0
            };
            this._scrollError = 0;
        }
        this._hostSink(message);
    }
    /**
     * Number of items to display.
     */ get _num() {
        if (this._first === -1 || this._last === -1) return 0;
        return this._last - this._first + 1;
    }
    _checkThresholds() {
        if (this._viewDim1 === 0 && this._num > 0 || this._pin !== null) this._scheduleReflow();
        else {
            const min = Math.max(0, this._scrollPosition - this._overhang);
            const max = Math.min(this._scrollSize, this._scrollPosition + this._viewDim1 + this._overhang);
            if (this._physicalMin > min || this._physicalMax < max) this._scheduleReflow();
            else this._updateVisibleIndices({
                emit: true
            });
        }
    }
    /**
     * Find the indices of the first and last items to intersect the viewport.
     * Emit a visibleindiceschange event when either index changes.
     */ _updateVisibleIndices(options) {
        if (this._first === -1 || this._last === -1) return;
        let firstVisible = this._first;
        while(firstVisible < this._last && Math.round(this._getItemPosition(firstVisible)[this._positionDim] + this._getItemSize(firstVisible)[this._sizeDim]) <= Math.round(this._scrollPosition))firstVisible++;
        let lastVisible = this._last;
        while(lastVisible > this._first && Math.round(this._getItemPosition(lastVisible)[this._positionDim]) >= Math.round(this._scrollPosition + this._viewDim1))lastVisible--;
        if (firstVisible !== this._firstVisible || lastVisible !== this._lastVisible) {
            this._firstVisible = firstVisible;
            this._lastVisible = lastVisible;
            if (options && options.emit) this._sendVisibilityChangedMessage();
        }
    }
}


const $7bb99ca3e158fea4$export$ccc7b0636abaffc3 = (config)=>Object.assign({
        type: $7bb99ca3e158fea4$export$d73a6b0c7e31529f
    }, config);
function $7bb99ca3e158fea4$var$leadingMargin(direction) {
    return direction === 'horizontal' ? 'marginLeft' : 'marginTop';
}
function $7bb99ca3e158fea4$var$trailingMargin(direction) {
    return direction === 'horizontal' ? 'marginRight' : 'marginBottom';
}
function $7bb99ca3e158fea4$var$offset(direction) {
    return direction === 'horizontal' ? 'xOffset' : 'yOffset';
}
function $7bb99ca3e158fea4$var$collapseMargins(a, b) {
    const m = [
        a,
        b
    ].sort();
    return m[1] <= 0 ? Math.min(...m) : m[0] >= 0 ? Math.max(...m) : m[0] + m[1];
}
class $7bb99ca3e158fea4$var$MetricsCache {
    constructor(){
        this._childSizeCache = new (0, $ada89af8a6b41f40$export$f137a505d4546509)();
        this._marginSizeCache = new (0, $ada89af8a6b41f40$export$f137a505d4546509)();
        this._metricsCache = new Map();
    }
    update(metrics, direction) {
        const marginsToUpdate = new Set();
        Object.keys(metrics).forEach((key)=>{
            const k = Number(key);
            this._metricsCache.set(k, metrics[k]);
            this._childSizeCache.set(k, metrics[k][(0, $da15e1c70bd0293d$export$29850d3944833d4a)(direction)]);
            marginsToUpdate.add(k);
            marginsToUpdate.add(k + 1);
        });
        for (const k of marginsToUpdate){
            const a = this._metricsCache.get(k)?.[$7bb99ca3e158fea4$var$leadingMargin(direction)] || 0;
            const b = this._metricsCache.get(k - 1)?.[$7bb99ca3e158fea4$var$trailingMargin(direction)] || 0;
            this._marginSizeCache.set(k, $7bb99ca3e158fea4$var$collapseMargins(a, b));
        }
    }
    get averageChildSize() {
        return this._childSizeCache.averageSize;
    }
    get totalChildSize() {
        return this._childSizeCache.totalSize;
    }
    get averageMarginSize() {
        return this._marginSizeCache.averageSize;
    }
    get totalMarginSize() {
        return this._marginSizeCache.totalSize;
    }
    getLeadingMarginValue(index, direction) {
        return this._metricsCache.get(index)?.[$7bb99ca3e158fea4$var$leadingMargin(direction)] || 0;
    }
    getChildSize(index) {
        return this._childSizeCache.getSize(index);
    }
    getMarginSize(index) {
        return this._marginSizeCache.getSize(index);
    }
    clear() {
        this._childSizeCache.clear();
        this._marginSizeCache.clear();
        this._metricsCache.clear();
    }
}
class $7bb99ca3e158fea4$export$d73a6b0c7e31529f extends (0, $da15e1c70bd0293d$export$64943d2e59d72a29) {
    constructor(){
        super(...arguments);
        /**
         * Initial estimate of item size
         */ this._itemSize = {
            width: 100,
            height: 100
        };
        /**
         * Indices of children mapped to their (position and length) in the scrolling
         * direction. Used to keep track of children that are in range.
         */ this._physicalItems = new Map();
        /**
         * Used in tandem with _physicalItems to track children in range across
         * reflows.
         */ this._newPhysicalItems = new Map();
        /**
         * Width and height of children by their index.
         */ this._metricsCache = new $7bb99ca3e158fea4$var$MetricsCache();
        /**
         * anchorIdx is the anchor around which we reflow. It is designed to allow
         * jumping to any point of the scroll size. We choose it once and stick with
         * it until stable. _first and _last are deduced around it.
         */ this._anchorIdx = null;
        /**
         * Position in the scrolling direction of the anchor child.
         */ this._anchorPos = null;
        /**
         * Whether all children in range were in range during the previous reflow.
         */ this._stable = true;
        this._measureChildren = true;
        this._estimate = true;
    }
    // protected _defaultConfig: BaseLayoutConfig = Object.assign({}, super._defaultConfig, {
    // })
    // constructor(config: Layout1dConfig) {
    //   super(config);
    // }
    get measureChildren() {
        return this._measureChildren;
    }
    /**
     * Determine the average size of all children represented in the sizes
     * argument.
     */ updateItemSizes(sizes) {
        this._metricsCache.update(sizes, this.direction);
        // if (this._nMeasured) {
        // this._updateItemSize();
        this._scheduleReflow();
    // }
    }
    /**
     * Set the average item size based on the total length and number of children
     * in range.
     */ // _updateItemSize() {
    //   // Keep integer values.
    //   this._itemSize[this._sizeDim] = this._metricsCache.averageChildSize;
    // }
    _getPhysicalItem(idx) {
        return this._newPhysicalItems.get(idx) ?? this._physicalItems.get(idx);
    }
    _getSize(idx) {
        const item = this._getPhysicalItem(idx);
        return item && this._metricsCache.getChildSize(idx);
    }
    _getAverageSize() {
        return this._metricsCache.averageChildSize || this._itemSize[this._sizeDim];
    }
    _estimatePosition(idx) {
        const c = this._metricsCache;
        if (this._first === -1 || this._last === -1) return c.averageMarginSize + idx * (c.averageMarginSize + this._getAverageSize());
        else if (idx < this._first) {
            const delta = this._first - idx;
            const refItem = this._getPhysicalItem(this._first);
            return refItem.pos - (c.getMarginSize(this._first - 1) || c.averageMarginSize) - (delta * c.averageChildSize + (delta - 1) * c.averageMarginSize);
        } else {
            const delta = idx - this._last;
            const refItem = this._getPhysicalItem(this._last);
            return refItem.pos + (c.getChildSize(this._last) || c.averageChildSize) + (c.getMarginSize(this._last) || c.averageMarginSize) + delta * (c.averageChildSize + c.averageMarginSize);
        }
    }
    /**
     * Returns the position in the scrolling direction of the item at idx.
     * Estimates it if the item at idx is not in the DOM.
     */ _getPosition(idx) {
        const item = this._getPhysicalItem(idx);
        const { averageMarginSize: averageMarginSize } = this._metricsCache;
        return idx === 0 ? this._metricsCache.getMarginSize(0) ?? averageMarginSize : item ? item.pos : this._estimatePosition(idx);
    }
    _calculateAnchor(lower, upper) {
        if (lower <= 0) return 0;
        if (upper > this._scrollSize - this._viewDim1) return this.items.length - 1;
        return Math.max(0, Math.min(this.items.length - 1, Math.floor((lower + upper) / 2 / this._delta)));
    }
    _getAnchor(lower, upper) {
        if (this._physicalItems.size === 0) return this._calculateAnchor(lower, upper);
        if (this._first < 0) return this._calculateAnchor(lower, upper);
        if (this._last < 0) return this._calculateAnchor(lower, upper);
        const firstItem = this._getPhysicalItem(this._first), lastItem = this._getPhysicalItem(this._last), firstMin = firstItem.pos, lastMin = lastItem.pos, lastMax = lastMin + this._metricsCache.getChildSize(this._last);
        if (lastMax < lower) // Window is entirely past physical items, calculate new anchor
        return this._calculateAnchor(lower, upper);
        if (firstMin > upper) // Window is entirely before physical items, calculate new anchor
        return this._calculateAnchor(lower, upper);
        // Window contains a physical item
        // Find one, starting with the one that was previously first visible
        let candidateIdx = this._firstVisible - 1;
        let cMax = -Infinity;
        while(cMax < lower){
            const candidate = this._getPhysicalItem(++candidateIdx);
            cMax = candidate.pos + this._metricsCache.getChildSize(candidateIdx);
        }
        return candidateIdx;
    }
    /**
     * Updates _first and _last based on items that should be in the current
     * viewed range.
     */ _getActiveItems() {
        if (this._viewDim1 === 0 || this.items.length === 0) this._clearItems();
        else this._getItems();
    }
    /**
     * Sets the range to empty.
     */ _clearItems() {
        this._first = -1;
        this._last = -1;
        this._physicalMin = 0;
        this._physicalMax = 0;
        const items = this._newPhysicalItems;
        this._newPhysicalItems = this._physicalItems;
        this._newPhysicalItems.clear();
        this._physicalItems = items;
        this._stable = true;
    }
    /*
     * Updates _first and _last based on items that should be in the given range.
     */ _getItems() {
        const items = this._newPhysicalItems;
        this._stable = true;
        let lower, upper;
        // The anchorIdx is the anchor around which we reflow. It is designed to
        // allow jumping to any point of the scroll size. We choose it once and
        // stick with it until stable. first and last are deduced around it.
        // If we have a pinned item, we anchor on it
        if (this.pin !== null) {
            const { index: index } = this.pin;
            this._anchorIdx = index;
            this._anchorPos = this._getPosition(index);
        }
        // Determine the lower and upper bounds of the region to be
        // rendered, relative to the viewport
        lower = this._scrollPosition - this._overhang; //leadingOverhang;
        upper = this._scrollPosition + this._viewDim1 + this._overhang; // trailingOverhang;
        if (upper < 0 || lower > this._scrollSize) {
            this._clearItems();
            return;
        }
        // If we are scrolling to a specific index or if we are doing another
        // pass to stabilize a previously started reflow, we will already
        // have an anchor. If not, establish an anchor now.
        if (this._anchorIdx === null || this._anchorPos === null) {
            this._anchorIdx = this._getAnchor(lower, upper);
            this._anchorPos = this._getPosition(this._anchorIdx);
        }
        let anchorSize = this._getSize(this._anchorIdx);
        if (anchorSize === undefined) {
            this._stable = false;
            anchorSize = this._getAverageSize();
        }
        const anchorLeadingMargin = this._metricsCache.getMarginSize(this._anchorIdx) ?? this._metricsCache.averageMarginSize;
        const anchorTrailingMargin = this._metricsCache.getMarginSize(this._anchorIdx + 1) ?? this._metricsCache.averageMarginSize;
        if (this._anchorIdx === 0) this._anchorPos = anchorLeadingMargin;
        if (this._anchorIdx === this.items.length - 1) this._anchorPos = this._scrollSize - anchorTrailingMargin - anchorSize;
        // Anchor might be outside bounds, so prefer correcting the error and keep
        // that anchorIdx.
        let anchorErr = 0;
        if (this._anchorPos + anchorSize + anchorTrailingMargin < lower) anchorErr = lower - (this._anchorPos + anchorSize + anchorTrailingMargin);
        if (this._anchorPos - anchorLeadingMargin > upper) anchorErr = upper - (this._anchorPos - anchorLeadingMargin);
        if (anchorErr) {
            this._scrollPosition -= anchorErr;
            lower -= anchorErr;
            upper -= anchorErr;
            this._scrollError += anchorErr;
        }
        items.set(this._anchorIdx, {
            pos: this._anchorPos,
            size: anchorSize
        });
        this._first = this._last = this._anchorIdx;
        this._physicalMin = this._anchorPos - anchorLeadingMargin;
        this._physicalMax = this._anchorPos + anchorSize + anchorTrailingMargin;
        while(this._physicalMin > lower && this._first > 0){
            let size = this._getSize(--this._first);
            if (size === undefined) {
                this._stable = false;
                size = this._getAverageSize();
            }
            let margin = this._metricsCache.getMarginSize(this._first);
            if (margin === undefined) {
                this._stable = false;
                margin = this._metricsCache.averageMarginSize;
            }
            this._physicalMin -= size;
            const pos = this._physicalMin;
            items.set(this._first, {
                pos: pos,
                size: size
            });
            this._physicalMin -= margin;
            if (this._stable === false && this._estimate === false) break;
        }
        while(this._physicalMax < upper && this._last < this.items.length - 1){
            let size = this._getSize(++this._last);
            if (size === undefined) {
                this._stable = false;
                size = this._getAverageSize();
            }
            let margin = this._metricsCache.getMarginSize(this._last);
            if (margin === undefined) {
                this._stable = false;
                margin = this._metricsCache.averageMarginSize;
            }
            const pos = this._physicalMax;
            items.set(this._last, {
                pos: pos,
                size: size
            });
            this._physicalMax += size + margin;
            if (!this._stable && !this._estimate) break;
        }
        // This handles the cases where we were relying on estimated sizes.
        const extentErr = this._calculateError();
        if (extentErr) {
            this._physicalMin -= extentErr;
            this._physicalMax -= extentErr;
            this._anchorPos -= extentErr;
            this._scrollPosition -= extentErr;
            items.forEach((item)=>item.pos -= extentErr);
            this._scrollError += extentErr;
        }
        if (this._stable) {
            this._newPhysicalItems = this._physicalItems;
            this._newPhysicalItems.clear();
            this._physicalItems = items;
        }
    }
    _calculateError() {
        if (this._first === 0) return this._physicalMin;
        else if (this._physicalMin <= 0) return this._physicalMin - this._first * this._delta;
        else if (this._last === this.items.length - 1) return this._physicalMax - this._scrollSize;
        else if (this._physicalMax >= this._scrollSize) return this._physicalMax - this._scrollSize + (this.items.length - 1 - this._last) * this._delta;
        return 0;
    }
    _reflow() {
        const { _first: _first, _last: _last } = this;
        super._reflow();
        if (this._first === -1 && this._last == -1 || this._first === _first && this._last === _last) this._resetReflowState();
    }
    _resetReflowState() {
        this._anchorIdx = null;
        this._anchorPos = null;
        this._stable = true;
    }
    _updateScrollSize() {
        const { averageMarginSize: averageMarginSize } = this._metricsCache;
        this._scrollSize = Math.max(1, this.items.length * (averageMarginSize + this._getAverageSize()) + averageMarginSize);
    }
    /**
     * Returns the average size (precise or estimated) of an item in the scrolling direction,
     * including any surrounding space.
     */ get _delta() {
        const { averageMarginSize: averageMarginSize } = this._metricsCache;
        return this._getAverageSize() + averageMarginSize;
    }
    /**
     * Returns the top and left positioning of the item at idx.
     */ _getItemPosition(idx) {
        return {
            [this._positionDim]: this._getPosition(idx),
            [this._secondaryPositionDim]: 0,
            [$7bb99ca3e158fea4$var$offset(this.direction)]: -(this._metricsCache.getLeadingMarginValue(idx, this.direction) ?? this._metricsCache.averageMarginSize)
        };
    }
    /**
     * Returns the height and width of the item at idx.
     */ _getItemSize(idx) {
        return {
            [this._sizeDim]: this._getSize(idx) || this._getAverageSize(),
            [this._secondarySizeDim]: this._itemSize[this._secondarySizeDim]
        };
    }
    _viewDim2Changed() {
        this._metricsCache.clear();
        this._scheduleReflow();
    }
}




var $c9361041b5bd802c$var$i = Symbol.for("preact-signals");
function $c9361041b5bd802c$var$t() {
    if (!($c9361041b5bd802c$var$s > 1)) {
        var i, t = !1;
        while(void 0 !== $c9361041b5bd802c$var$h){
            var r = $c9361041b5bd802c$var$h;
            $c9361041b5bd802c$var$h = void 0;
            $c9361041b5bd802c$var$f++;
            while(void 0 !== r){
                var o = r.o;
                r.o = void 0;
                r.f &= -3;
                if (!(8 & r.f) && $c9361041b5bd802c$var$c(r)) try {
                    r.c();
                } catch (r) {
                    if (!t) {
                        i = r;
                        t = !0;
                    }
                }
                r = o;
            }
        }
        $c9361041b5bd802c$var$f = 0;
        $c9361041b5bd802c$var$s--;
        if (t) throw i;
    } else $c9361041b5bd802c$var$s--;
}
function $c9361041b5bd802c$export$712ea50be43a7858(i) {
    if ($c9361041b5bd802c$var$s > 0) return i();
    $c9361041b5bd802c$var$s++;
    try {
        return i();
    } finally{
        $c9361041b5bd802c$var$t();
    }
}
var $c9361041b5bd802c$var$o = void 0;
function $c9361041b5bd802c$export$8c437e4d572e2f99(i) {
    var t = $c9361041b5bd802c$var$o;
    $c9361041b5bd802c$var$o = void 0;
    try {
        return i();
    } finally{
        $c9361041b5bd802c$var$o = t;
    }
}
var $c9361041b5bd802c$var$h = void 0, $c9361041b5bd802c$var$s = 0, $c9361041b5bd802c$var$f = 0, $c9361041b5bd802c$var$v = 0;
function $c9361041b5bd802c$var$e(i) {
    if (void 0 !== $c9361041b5bd802c$var$o) {
        var t = i.n;
        if (void 0 === t || t.t !== $c9361041b5bd802c$var$o) {
            t = {
                i: 0,
                S: i,
                p: $c9361041b5bd802c$var$o.s,
                n: void 0,
                t: $c9361041b5bd802c$var$o,
                e: void 0,
                x: void 0,
                r: t
            };
            if (void 0 !== $c9361041b5bd802c$var$o.s) $c9361041b5bd802c$var$o.s.n = t;
            $c9361041b5bd802c$var$o.s = t;
            i.n = t;
            if (32 & $c9361041b5bd802c$var$o.f) i.S(t);
            return t;
        } else if (-1 === t.i) {
            t.i = 0;
            if (void 0 !== t.n) {
                t.n.p = t.p;
                if (void 0 !== t.p) t.p.n = t.n;
                t.p = $c9361041b5bd802c$var$o.s;
                t.n = void 0;
                $c9361041b5bd802c$var$o.s.n = t;
                $c9361041b5bd802c$var$o.s = t;
            }
            return t;
        }
    }
}
function $c9361041b5bd802c$export$8210dfe1863c478(i, t) {
    this.v = i;
    this.i = 0;
    this.n = void 0;
    this.t = void 0;
    this.W = null == t ? void 0 : t.watched;
    this.Z = null == t ? void 0 : t.unwatched;
    this.name = null == t ? void 0 : t.name;
}
$c9361041b5bd802c$export$8210dfe1863c478.prototype.brand = $c9361041b5bd802c$var$i;
$c9361041b5bd802c$export$8210dfe1863c478.prototype.h = function() {
    return !0;
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.S = function(i) {
    var t = this, r = this.t;
    if (r !== i && void 0 === i.e) {
        i.x = r;
        this.t = i;
        if (void 0 !== r) r.e = i;
        else $c9361041b5bd802c$export$8c437e4d572e2f99(function() {
            var i;
            null == (i = t.W) || i.call(t);
        });
    }
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.U = function(i) {
    var t = this;
    if (void 0 !== this.t) {
        var r = i.e, o = i.x;
        if (void 0 !== r) {
            r.x = o;
            i.e = void 0;
        }
        if (void 0 !== o) {
            o.e = r;
            i.x = void 0;
        }
        if (i === this.t) {
            this.t = o;
            if (void 0 === o) $c9361041b5bd802c$export$8c437e4d572e2f99(function() {
                var i;
                null == (i = t.Z) || i.call(t);
            });
        }
    }
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.subscribe = function(i) {
    var t = this;
    return $c9361041b5bd802c$export$dc573d8a6576cdb3(function() {
        var r = t.value, n = $c9361041b5bd802c$var$o;
        $c9361041b5bd802c$var$o = void 0;
        try {
            i(r);
        } finally{
            $c9361041b5bd802c$var$o = n;
        }
    }, {
        name: "sub"
    });
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.valueOf = function() {
    return this.value;
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.toString = function() {
    return this.value + "";
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.toJSON = function() {
    return this.value;
};
$c9361041b5bd802c$export$8210dfe1863c478.prototype.peek = function() {
    var i = $c9361041b5bd802c$var$o;
    $c9361041b5bd802c$var$o = void 0;
    try {
        return this.value;
    } finally{
        $c9361041b5bd802c$var$o = i;
    }
};
Object.defineProperty($c9361041b5bd802c$export$8210dfe1863c478.prototype, "value", {
    get: function() {
        var i = $c9361041b5bd802c$var$e(this);
        if (void 0 !== i) i.i = this.i;
        return this.v;
    },
    set: function(i) {
        if (i !== this.v) {
            if ($c9361041b5bd802c$var$f > 100) throw new Error("Cycle detected");
            this.v = i;
            this.i++;
            $c9361041b5bd802c$var$v++;
            $c9361041b5bd802c$var$s++;
            try {
                for(var r = this.t; void 0 !== r; r = r.x)r.t.N();
            } finally{
                $c9361041b5bd802c$var$t();
            }
        }
    }
});
function $c9361041b5bd802c$export$e2ef10f86a8d60e8(i, t) {
    return new $c9361041b5bd802c$export$8210dfe1863c478(i, t);
}
function $c9361041b5bd802c$var$c(i) {
    for(var t = i.s; void 0 !== t; t = t.n)if (t.S.i !== t.i || !t.S.h() || t.S.i !== t.i) return !0;
    return !1;
}
function $c9361041b5bd802c$var$a(i) {
    for(var t = i.s; void 0 !== t; t = t.n){
        var r = t.S.n;
        if (void 0 !== r) t.r = r;
        t.S.n = t;
        t.i = -1;
        if (void 0 === t.n) {
            i.s = t;
            break;
        }
    }
}
function $c9361041b5bd802c$var$l(i) {
    var t = i.s, r = void 0;
    while(void 0 !== t){
        var o = t.p;
        if (-1 === t.i) {
            t.S.U(t);
            if (void 0 !== o) o.n = t.n;
            if (void 0 !== t.n) t.n.p = o;
        } else r = t;
        t.S.n = t.r;
        if (void 0 !== t.r) t.r = void 0;
        t = o;
    }
    i.s = r;
}
function $c9361041b5bd802c$export$836eee5a40e84ba8(i, t) {
    $c9361041b5bd802c$export$8210dfe1863c478.call(this, void 0);
    this.x = i;
    this.s = void 0;
    this.g = $c9361041b5bd802c$var$v - 1;
    this.f = 4;
    this.W = null == t ? void 0 : t.watched;
    this.Z = null == t ? void 0 : t.unwatched;
    this.name = null == t ? void 0 : t.name;
}
$c9361041b5bd802c$export$836eee5a40e84ba8.prototype = new $c9361041b5bd802c$export$8210dfe1863c478;
$c9361041b5bd802c$export$836eee5a40e84ba8.prototype.h = function() {
    this.f &= -3;
    if (1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    this.f &= -5;
    if (this.g === $c9361041b5bd802c$var$v) return !0;
    this.g = $c9361041b5bd802c$var$v;
    this.f |= 1;
    if (this.i > 0 && !$c9361041b5bd802c$var$c(this)) {
        this.f &= -2;
        return !0;
    }
    var i = $c9361041b5bd802c$var$o;
    try {
        $c9361041b5bd802c$var$a(this);
        $c9361041b5bd802c$var$o = this;
        var t = this.x();
        if (16 & this.f || this.v !== t || 0 === this.i) {
            this.v = t;
            this.f &= -17;
            this.i++;
        }
    } catch (i) {
        this.v = i;
        this.f |= 16;
        this.i++;
    }
    $c9361041b5bd802c$var$o = i;
    $c9361041b5bd802c$var$l(this);
    this.f &= -2;
    return !0;
};
$c9361041b5bd802c$export$836eee5a40e84ba8.prototype.S = function(i) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(var t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $c9361041b5bd802c$export$8210dfe1863c478.prototype.S.call(this, i);
};
$c9361041b5bd802c$export$836eee5a40e84ba8.prototype.U = function(i) {
    if (void 0 !== this.t) {
        $c9361041b5bd802c$export$8210dfe1863c478.prototype.U.call(this, i);
        if (void 0 === this.t) {
            this.f &= -33;
            for(var t = this.s; void 0 !== t; t = t.n)t.S.U(t);
        }
    }
};
$c9361041b5bd802c$export$836eee5a40e84ba8.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var i = this.t; void 0 !== i; i = i.x)i.t.N();
    }
};
Object.defineProperty($c9361041b5bd802c$export$836eee5a40e84ba8.prototype, "value", {
    get: function() {
        if (1 & this.f) throw new Error("Cycle detected");
        var i = $c9361041b5bd802c$var$e(this);
        this.h();
        if (void 0 !== i) i.i = this.i;
        if (16 & this.f) throw this.v;
        return this.v;
    }
});
function $c9361041b5bd802c$export$2983e091f1a1e8e2(i, t) {
    return new $c9361041b5bd802c$export$836eee5a40e84ba8(i, t);
}
function $c9361041b5bd802c$var$_(i) {
    var r = i.u;
    i.u = void 0;
    if ("function" == typeof r) {
        $c9361041b5bd802c$var$s++;
        var n = $c9361041b5bd802c$var$o;
        $c9361041b5bd802c$var$o = void 0;
        try {
            r();
        } catch (t) {
            i.f &= -2;
            i.f |= 8;
            $c9361041b5bd802c$var$b(i);
            throw t;
        } finally{
            $c9361041b5bd802c$var$o = n;
            $c9361041b5bd802c$var$t();
        }
    }
}
function $c9361041b5bd802c$var$b(i) {
    for(var t = i.s; void 0 !== t; t = t.n)t.S.U(t);
    i.x = void 0;
    i.s = void 0;
    $c9361041b5bd802c$var$_(i);
}
function $c9361041b5bd802c$var$g(i) {
    if ($c9361041b5bd802c$var$o !== this) throw new Error("Out-of-order effect");
    $c9361041b5bd802c$var$l(this);
    $c9361041b5bd802c$var$o = i;
    this.f &= -2;
    if (8 & this.f) $c9361041b5bd802c$var$b(this);
    $c9361041b5bd802c$var$t();
}
function $c9361041b5bd802c$export$a32b0b1c1ac59d04(i, t) {
    this.x = i;
    this.u = void 0;
    this.s = void 0;
    this.o = void 0;
    this.f = 32;
    this.name = null == t ? void 0 : t.name;
}
$c9361041b5bd802c$export$a32b0b1c1ac59d04.prototype.c = function() {
    var i = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        var t = this.x();
        if ("function" == typeof t) this.u = t;
    } finally{
        i();
    }
};
$c9361041b5bd802c$export$a32b0b1c1ac59d04.prototype.S = function() {
    if (1 & this.f) throw new Error("Cycle detected");
    this.f |= 1;
    this.f &= -9;
    $c9361041b5bd802c$var$_(this);
    $c9361041b5bd802c$var$a(this);
    $c9361041b5bd802c$var$s++;
    var i = $c9361041b5bd802c$var$o;
    $c9361041b5bd802c$var$o = this;
    return $c9361041b5bd802c$var$g.bind(this, i);
};
$c9361041b5bd802c$export$a32b0b1c1ac59d04.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 2;
        this.o = $c9361041b5bd802c$var$h;
        $c9361041b5bd802c$var$h = this;
    }
};
$c9361041b5bd802c$export$a32b0b1c1ac59d04.prototype.d = function() {
    this.f |= 8;
    if (!(1 & this.f)) $c9361041b5bd802c$var$b(this);
};
$c9361041b5bd802c$export$a32b0b1c1ac59d04.prototype.dispose = function() {
    this.d();
};
function $c9361041b5bd802c$export$dc573d8a6576cdb3(i, t) {
    var r = new $c9361041b5bd802c$export$a32b0b1c1ac59d04(i, t);
    try {
        r.c();
    } catch (i) {
        r.d();
        throw i;
    }
    var o = r.d.bind(r);
    o[Symbol.dispose] = o;
    return o;
}


'use strict';
/**
 * Eventifies an object (built with inspiration from smokesignals)
 * @param {object} obj the object to be eventified
 * @returns the object
 */ let $8e5676bd73916c78$export$52d98889efa7d412 = (obj)=>{
    // Previously eventified?
    if (obj.on && obj.emit) return obj;
    obj._events_handlers = Object.create(null);
    obj.clearEvents = $8e5676bd73916c78$var$clearEvents;
    obj.emitOnce = $8e5676bd73916c78$var$emitOnce;
    obj.emitAsync = $8e5676bd73916c78$var$emitAsync;
    obj.emit = $8e5676bd73916c78$var$emit;
    obj.once = $8e5676bd73916c78$var$once;
    obj.off = $8e5676bd73916c78$var$off;
    obj.deEventify = $8e5676bd73916c78$var$deEventify;
    /**
     * Adds a listener for an event
     * @param {string} eventName the name of the event
     * @param {*} handler
     * @returns {object} the object
     */ obj.on = function(eventName, handler) {
        if (!handler) return obj;
        let handlerList = obj._events_handlers[eventName];
        if (!handlerList) handlerList = obj._events_handlers[eventName] = [];
        handlerList.push(handler);
        return {
            unsubscribe: ()=>{
                obj.off?.(eventName, handler);
                return obj;
            },
            eventName: eventName,
            on: obj.on.bind(obj)
        };
    };
    return obj;
};
/**
 * Adds a listener for an event where the callbackhandler is only called once
 * @param {string} eventName the name of the event
 * @param {*} handler
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$once(eventName, handler) {
    let obj = this;
    let subscription = obj.on(eventName, (eventData)=>{
        subscription.unsubscribe();
        handler.call(obj, eventData);
        subscription = null;
        handler = null;
    });
    return subscription;
}
/**
 * Removes a listener for an event
 * @param {string} eventName the name of the event
 * @param {function} handler the callback function to remove
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$off(eventName, handler) {
    let obj = this;
    let handlerList = obj._events_handlers[eventName];
    if (!(handlerList && handler)) return obj;
    // Remove all added events for this handler
    let index = handlerList.length;
    while(--index >= 0)if (handlerList[index] === handler) handlerList.splice(index, 1);
    return obj;
}
/**
 * Emits an event only once
 * @param {string} eventName the name of the event
 * @param {*} eventData
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$emitOnce(eventName, eventData) {
    let obj = this;
    let handlerList = obj._events_handlers[eventName];
    if (!handlerList) handlerList = obj._events_handlers[eventName] = [];
    $8e5676bd73916c78$var$emit.call(obj, eventName, eventData);
    handlerList._events_oneTimeEventHasFired = true;
    return obj;
}
/**
 * Emits an event asynchrounosly
 * @param {string} eventName the name of the event
 * @param {*} eventData
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$emitAsync(eventName, eventData) {
    let obj = this;
    setTimeout(()=>{
        obj.emit(eventName, eventData);
    }, 0);
    return obj;
}
/**
 * Emits an event
 * @param {string} eventName the name of the event
 * @param {*} eventData
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$emit(eventName, eventData) {
    let obj = this;
    let handlerList = obj._events_handlers[eventName];
    if (!handlerList?.length) return obj;
    if (handlerList._events_oneTimeEventHasFired) return obj;
    let data = typeof eventData === 'function' ? eventData() : eventData;
    // Copy the array to make sure code inside events that might unregister etc.
    // does not prevent all the current attached handlers from beeing called.
    handlerList = handlerList.slice();
    for(let i = 0, length = handlerList.length; i < length; i++)handlerList[i]?.call(obj, data);
    return obj;
}
/**
 * Removes every trace of events on the object
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$deEventify() {
    let obj = this;
    obj.clearEvents?.();
    obj.on = $8e5676bd73916c78$var$noop;
    obj.set = $8e5676bd73916c78$var$noop;
    obj.get = $8e5676bd73916c78$var$noop;
    obj.off = $8e5676bd73916c78$var$noop;
    obj.once = $8e5676bd73916c78$var$noop;
    obj.emit = $8e5676bd73916c78$var$noop;
    obj.emitAsync = $8e5676bd73916c78$var$noop;
    obj.emitOnce = $8e5676bd73916c78$var$noop;
    obj.clearEvents = $8e5676bd73916c78$var$noop;
    obj._events_handlers = null;
    return obj;
}
/**
 *
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$noop() {
    return this;
}
/**
 *
 * @returns {object} the object
 */ function $8e5676bd73916c78$var$clearEvents() {
    let obj = this;
    obj._events_handlers && Object.keys(obj._events_handlers).forEach((key)=>{
        if (obj._events_handlers[key]) {
            obj._events_handlers[key].length = 0;
            obj._events_handlers[key] = null;
        }
    });
    obj._events_handlers = Object.create(null);
    return obj;
}


var $f8f19630d13eb642$exports = {};

$parcel$export($f8f19630d13eb642$exports, "newId", function () { return $f8f19630d13eb642$export$9ffd10a3fbdc175b; });
$parcel$export($f8f19630d13eb642$exports, "isObject", function () { return $f8f19630d13eb642$export$a6cdc56e425d0d0a; });
$parcel$export($f8f19630d13eb642$exports, "isArray", function () { return $f8f19630d13eb642$export$43bee75e5e14138e; });
$parcel$export($f8f19630d13eb642$exports, "camelize", function () { return $f8f19630d13eb642$export$161d051f5dd25de7; });
$parcel$export($f8f19630d13eb642$exports, "kebabelize", function () { return $f8f19630d13eb642$export$4909bbd57b1beef8; });
$parcel$export($f8f19630d13eb642$exports, "getIsoDateStr", function () { return $f8f19630d13eb642$export$2c67d5861a969420; });
$parcel$export($f8f19630d13eb642$exports, "defineProperty", function () { return $f8f19630d13eb642$export$fdab3c20aae16ddf; });
$parcel$export($f8f19630d13eb642$exports, "defineReadOnlyProperty", function () { return $f8f19630d13eb642$export$b5c410d4913048d5; });
$parcel$export($f8f19630d13eb642$exports, "tryParse", function () { return $f8f19630d13eb642$export$468ff95b83d315e5; });
$parcel$export($f8f19630d13eb642$exports, "clone", function () { return $f8f19630d13eb642$export$9cd59f9826255e47; });
'use strict';
let $f8f19630d13eb642$var$timeouts = [];
let $f8f19630d13eb642$var$messageName = "zero-timeout-message";
// INFO: https://dbaron.org/log/20100309-faster-timeouts
/**
 * Calls a function in an async manner in as short a timespan as possible
 * @param {function} fn
 */ let $f8f19630d13eb642$var$setZeroTimeout = (fn)=>{
    $f8f19630d13eb642$var$timeouts.push(fn);
    window.postMessage($f8f19630d13eb642$var$messageName, "*");
};
/**
 * Handles postMessages sent to the current window
 * @param {MessageEvent} event
 */ let $f8f19630d13eb642$var$handleZeroTimeoutMessage = (event)=>{
    if (event.source === window && event.data === $f8f19630d13eb642$var$messageName) {
        event.stopPropagation();
        $f8f19630d13eb642$var$timeouts.length && $f8f19630d13eb642$var$timeouts.shift()();
    }
};
if (!window.setZeroTimeout) {
    window.setZeroTimeout = $f8f19630d13eb642$var$setZeroTimeout;
    window.addEventListener("message", $f8f19630d13eb642$var$handleZeroTimeoutMessage, true);
}
let $f8f19630d13eb642$var$uniqueCounter = 0;
let $f8f19630d13eb642$export$9ffd10a3fbdc175b = (prefix = 'id_')=>prefix + ++$f8f19630d13eb642$var$uniqueCounter;
let $f8f19630d13eb642$export$a6cdc56e425d0d0a = (obj)=>!!(obj && typeof obj === 'object' && !Array.isArray(obj) && obj.contructor !== Date);
let $f8f19630d13eb642$export$43bee75e5e14138e = (obj)=>Array.isArray(obj);
let $f8f19630d13eb642$export$161d051f5dd25de7 = (str)=>str.replace(/-./g, (x)=>x[1].toUpperCase());
let $f8f19630d13eb642$export$4909bbd57b1beef8 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
let $f8f19630d13eb642$export$2c67d5861a969420 = (date)=>new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0]; // INFO: https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd
if (!window.queueMicrotask) window.queueMicrotask = (fn)=>Promise.resolve().then(fn);
/**
 * Define a get/set property on an object
 * @param {object} obj the object
 * @param {string} key the property name
 * @param {any} initialValue the intial value of the property
 * @param {function} callbackOnUpdatedValue
 */ let $f8f19630d13eb642$export$fdab3c20aae16ddf = (obj, key, initialValue, callbackOnUpdatedValue)=>{
    let propName = '$$prop$$' + key.toLowerCase();
    obj[propName] = initialValue;
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get: ()=>obj[propName],
        set (value) {
            let oldValue = obj[propName];
            if (oldValue !== value) {
                obj[propName] = value;
                callbackOnUpdatedValue?.(key, oldValue, value);
            }
        }
    });
};
/**
 * Define a get/set property on an object
 * @param {object} obj the object
 * @param {string} key the property name
 * @param {any} value the value of the property
 */ let $f8f19630d13eb642$export$b5c410d4913048d5 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get: ()=>value
    });
};
// INFO: https://stackoverflow.com/questions/21485545/is-there-a-way-to-tell-if-an-es6-promise-is-fulfilled-rejected-resolved
let $f8f19630d13eb642$var$makeQueryablePromise = (promise)=>{
    if (promise.isResolved) return promise;
    let isResolved = false;
    let isRejected = false;
    let result = promise.then((v)=>{
        isResolved = true;
        return v;
    }, (e)=>{
        isRejected = true;
        throw e;
    });
    result.isSettled = ()=>isResolved || isRejected;
    result.isResolved = ()=>isResolved;
    result.isRejected = ()=>isRejected;
    return result;
};
/**
 * Try parsing a string as a json object
 * @param {string} str the string to be parsed
 * @returns {Object|Array|String} the parsed object or undefined if unsuccessful
 */ let $f8f19630d13eb642$export$468ff95b83d315e5 = (str)=>{
    try {
        return JSON.parse(str);
    } catch (e) {}
};
let $f8f19630d13eb642$export$9cd59f9826255e47 = (src)=>{
    if ($f8f19630d13eb642$export$43bee75e5e14138e(src)) return src.map((item)=>$f8f19630d13eb642$export$43bee75e5e14138e(item) || $f8f19630d13eb642$export$a6cdc56e425d0d0a(item) ? $f8f19630d13eb642$export$9cd59f9826255e47(item) : item);
    else if (!$f8f19630d13eb642$export$a6cdc56e425d0d0a(src)) return src;
    const cloned = Object.assign({}, src);
    Object.keys(cloned).forEach((key)=>{
        const value = cloned[key];
        if (value) {
            if ($f8f19630d13eb642$export$43bee75e5e14138e(value) || $f8f19630d13eb642$export$a6cdc56e425d0d0a(value)) cloned[key] = $f8f19630d13eb642$export$9cd59f9826255e47(value);
        }
    });
    return cloned;
};


const $b77b30c4d7cb9da3$var$version = '0.9.20';
let { isArray: $b77b30c4d7cb9da3$var$isArray, isObject: $b77b30c4d7cb9da3$var$isObject, defineProperty: $b77b30c4d7cb9da3$var$defineProperty, defineReadOnlyProperty: $b77b30c4d7cb9da3$var$defineReadOnlyProperty, tryParse: $b77b30c4d7cb9da3$var$tryParse, camelize: $b77b30c4d7cb9da3$var$camelize } = $f8f19630d13eb642$exports;
// INFO webcomponent rendering etc.
//      https://open-wc.org/blog/some-things-to-know-when-developing-with-lit/
//      https://open-wc.org/blog/lit-element-deepdive-in-batching-updates/
//      https://open-wc.org/blog/doing-a-flip-with-lit-html-2-0/
//      https://open-wc.org/guides/knowledge/events/
// lit-html templates documentation
//      https://lit.dev/docs/templates/overview/
/** Support events */ let $b77b30c4d7cb9da3$var$events = (0, $8e5676bd73916c78$export$52d98889efa7d412)(Object.create(null));
delete $b77b30c4d7cb9da3$var$events.deEventify;
delete $b77b30c4d7cb9da3$var$events.clearEvents;
let $b77b30c4d7cb9da3$var$noop = ()=>{};
// @ts-check
const $b77b30c4d7cb9da3$var$emptyAttrib = {};
/** @type {import('./lithtmltypes').CustomHTMLElementOptions} */ let $b77b30c4d7cb9da3$var$defaultOptions = {
    useShadowRoot: true,
    renderFrequency: 'batched' // raf? immediate? settimeout?
};
/**
 * Base class for new Custom Elements
 */ class $b77b30c4d7cb9da3$var$CustomHTMLElement extends HTMLElement {
    /**
     * @param {typeof import("./lithtmltypes").CustomHTMLElement} derivedClass derived class with potentially observedAttributes and/or observeProperties attached to it
     * @param {import("./lithtmltypes").CustomHTMLElementOptions} options optional CustomHTMLElementOptions
     */ constructor(derivedClass, options = {}){
        super();
        let self = this;
        self.options = Object.assign({}, $b77b30c4d7cb9da3$var$defaultOptions, options);
        /**
         * The name of the custom element
         * @type {string}
         */ self._tag = derivedClass.tag || 'missing-tag';
        /**
         * List of all observable properties
         * @type {string[]}
         */ self._obsProps = derivedClass?.observedProperties || [];
        /**
         * List of all the observable attributes.
         * @type {string[]}
         */ self._obsAttrs = derivedClass?.observedAttributes || [];
        // Make sure all observed attributes has a corresponding (observed) property
        self._attrToProps = Object.create(null);
        self._propToAttrs = Object.create(null);
        self._obsAttrs.forEach((attr)=>{
            let propName = $b77b30c4d7cb9da3$var$camelize(attr);
            self._attrToProps[attr] = propName;
            self._propToAttrs[propName] = attr;
            self._obsProps.indexOf(propName) === -1 && self._obsProps.push(propName);
        });
        /** The reason for the current render (mostly interesting for debugging purposes) */ self._renderReason = '';
        /** Indicate wheter the first initial render has been run or not */ self._firstRenderDone = false;
        /** Indicate wheter the first connection to the DOM has been run or not */ self._firstConnectedDone = false;
        /** Indicate wheter a requested async render is in progress or not */ self._requestedAsyncRender = false;
        /**
         * Property used in attributeChangedCallback to help seperate attributes beeing set by
         * calling internal $setAttrib method and beeing set externally by element.setAttribute.
         */ self._newAttribValue = $b77b30c4d7cb9da3$var$emptyAttrib;
        /**
         * List of currently changed properties/attributes that are batched and triggers an onAttributesChanged event
         * @type {import("./lithtmltypes").PropOrAttribChanged[]}
         */ self._chPropOrAttrs = [];
        /** Dictionary of all inital attributes on the element (populated in onFirstConnected) */ self.$attribs = Object.create(null);
        self.$attribsLC = Object.create(null);
        /**
         * Give the derived class the possibility to do some initalizing before setting up observed properties.
         * This can be useful to set the default value of observed properties without them triggering an
         * onPropertyChanged event.
         */ self.initalize?.();
        // Make sure we know when the observed properties are changed so that we can batch trigger a rerender
        // and trigger an onPropertyChanged event
        self._obsProps.forEach((propName)=>self._addReactiveProperty(propName));
    }
    /**
     * Defines a get/set wrapper around a property on the instance
     * @param {string} propName the property name
     */ _addReactiveProperty(propName) {
        let self = this;
        let changedProp = 'onChanged_' + propName;
        $b77b30c4d7cb9da3$var$defineProperty(self, propName, self[propName], (propName, oldValue, value)=>{
            self._chPropOrAttrs.push({
                name: propName,
                oldValue: oldValue,
                newValue: value
            });
            self._createRenderTask('observedPropChange');
            self.onPropertyChanged?.(propName, oldValue, value);
            self[changedProp]?.(oldValue, value);
            let attrName = self._propToAttrs[propName];
            if (attrName && !self._attribChangeInProgress) {
                self._propChangeInProgress = true;
                self.$setAttrib(attrName, value);
                self.onAttributeChanged?.(attrName, oldValue, value);
                self._propChangeInProgress = false;
            }
        });
    }
    /**
     * Create a task for rendering. The render is batched, meaning that updating the same property multiple
     * times or updating multiple different properties or attributes will only result in one render beeing called
     * at the end of the code running.
     * @param {string} renderReason description of the reason for calling this method
     */ _createRenderTask(renderReason) {
        let self = this;
        if (self._renderTask) return self._renderTask;
        this._renderReason = this._renderReason || renderReason;
        // Create a (micro)task for batch calling rendering
        self._renderTask = true;
        queueMicrotask(()=>{
            // Check to see if a _renderTask is still active. If ex. a render has just been done, the _renderTask is null
            // and there is no reason to do another render.
            self._renderTask && self._render();
        });
        return this;
    }
    /**
     * Calls the inherited render method and renders the result to DOM. It triggers the
     * shouldRender, willRender and onRendered methods, and the render can be stopped by
     * returning false from the shouldRender method (unless force is specified).
     * @param {boolean} [force] whether the render should be done no matter what
     */ _render(force) {
        let self = this;
        if (self._destroyed) return;
        // Do not render anything before the inital connection to the DOM has run. The reason we're preventing
        // this is that the shadowRoot (if in use) is not created before the initial connectedCallback has run.
        if (!self._firstConnectedDone) {
            self._renderTask = null;
            return;
        }
        let changedPropOrAttribs = self._chPropOrAttrs.splice(0);
        // Allow the component to stop the rendering
        let shouldRender = !force && self.shouldRender && self.shouldRender(changedPropOrAttribs);
        if (!force && shouldRender === false) {
            self._renderTask = null;
            return;
        }
        // Give the component a last change to update properties used in the render
        self.willRender?.(changedPropOrAttribs);
        // Trigger the onFirstRender if not already done
        if (!self._firstRenderDone && self.isConnected) {
            self.onFirstRender?.();
            self.$triggerEvent(self._tag + '-firstrender');
        }
        self._renderTask = null;
        self._chPropOrAttrs.length = 0;
        (0, $0585bced692c3b45$export$b3890eb0ae9dca99)(self.render(self._renderReason), self.shadowRoot || self, {
            host: self
        });
        // Trigger the onFirstRendered if not already done
        if (!self._firstRenderDone && self.isConnected) {
            self._firstRenderDone = true;
            self.onFirstRendered?.();
            self.$triggerEvent(self._tag + '-firstrendered');
        }
        self._renderReason = null;
        // Important that code in onRendered does not trigger a rerender, it's supposed to be
        // used to ex. set focus to an element etc. But in case it happens we try here to convert
        // it to an async render.
        if (self.onRendered) {
            self.onRendered(changedPropOrAttribs);
            if (self._renderTask) {
                self._renderTask = null;
                self.requestAsyncRender('renderRequestInOnRendered');
            }
        }
    }
    /**
     * Trigger and/or dispatch an event
     * @param {string} eventName the name of the event
     * @param {boolean} [dispatch] dispatch an event (default true)
     * @param {boolean} [event] trigger an lithtml event (default true)
     */ $triggerEvent(eventName, { dispatch: dispatch = true, event: event = true, data: data } = {}) {
        let self = this;
        dispatch && self.dispatchEvent(new CustomEvent(eventName, {
            bubbles: true,
            detail: data
        }));
        event && $b77b30c4d7cb9da3$var$events.emit(eventName, ()=>({
                event: eventName,
                target: self,
                id: self.id,
                data: data
            }));
        return self;
    }
    // TODO: https://stackblitz.com/edit/lit-html-script-tag?file=src%2Fscript.js
    /**
     * Force an immediate render, use if a synchronous render is needed.
     */ forceRender(renderReason) {
        this._renderReason = renderReason || 'forced';
        this._render(true);
        return this;
    }
    /**
     * Request a microtask-async render, use if some data not in observedAttributes or observedProperties
     * is updated and an update of the DOM is needed.
     * @param {string} [renderReason] info about the reason for rendering (mostly useful for debugging)
     */ requestRender(renderReason) {
        return this._createRenderTask(renderReason || 'requested');
    }
    /**
     * Request an async render, use if a 'real' async is needed, and not a microtask async render.
     * @param {string} [renderReason] info about the reason for rendering (mostly useful for debugging)
     */ requestAsyncRender(renderReason) {
        let self = this;
        if (self._requestedAsyncRender) return self;
        self._requestedAsyncRender = true;
        setZeroTimeout(()=>{
            self._createRenderTask(renderReason || 'asyncRequested');
            self._requestedAsyncRender = false;
        });
        return self;
    }
    /**
     * Event called when the CustomElement is removed from the DOM
     * INFO:
     *     https://nolanlawson.com/2024/12/01/avoiding-unnecessary-cleanup-work-in-disconnectedcallback/
     */ async disconnectedCallback() {
        let self = this;
        await Promise.resolve();
        // Check if the element is still connected, if so it's probably just beeing moved around the DOM
        if (self.isConnected) {
            self._elementHasJustAroundMovedInDOM = true;
            return;
        }
        // Make sure this will work with Firefox when moving elements between documents
        // INFO: https://jakearchibald.com/2025/firefox-custom-elements-iframes-bug/
        //rescueElementPrototype(self);
        self.onDisconnected?.();
        self.$triggerEvent(self._tag + '-disconnected');
    }
    /** Event called when the CustomElement is added/attached to the DOM */ async connectedCallback() {
        let self = this;
        // If self._elementHasJustAroundMovedInDOM is true this means that the element has been moved instead
        // of having a 'real' disconnect, so we make sure that we trigger a moved event instead
        // of connected.
        if (self._elementHasJustAroundMovedInDOM) {
            self._elementHasJustAroundMovedInDOM = false;
            self.onMoved?.();
            self.$triggerEvent(self._tag + '-moved');
            return;
        }
        if (!self._firstConnectedDone) {
            self._firstConnectedDone = true;
            // Populate all initial attributes
            self.getAttributeNames().forEach((attrName)=>{
                let propName = $b77b30c4d7cb9da3$var$camelize(attrName);
                self.$attribs[propName] = self[propName] || self.$getValFromString(self.getAttribute(attrName));
                self.$attribsLC[propName.toLowerCase()] = self.$attribs[propName];
            });
            // Create shadowRoot? The default is true, but it can be overridden by using the attribute use-shadow-root.
            //let useShadowRoot = self.$getAttrib('use-shadow-root');
            //if (useShadowRoot === true || useShadowRoot === false) {
            //    self.options.useShadowRoot = useShadowRoot;
            //}
            self.options.useShadowRoot && self.attachShadow({
                mode: 'open'
            });
            // If the user is has tried to set the shadowStyle before the shadowRoot is created
            // we now make sure it's set
            if (self._css) {
                self.$setShadowStyle(self._css);
                self._css = null;
            }
            self.onFirstConnected?.();
            self.$triggerEvent(self._tag + '-firstconnected');
            // Make sure we trigger an initial render. After the render has run once, there is no need
            // to trigger a new one each time the element is reconnected, since any changes demanding a
            // render will happen based on prop/attrib changes or specifically calling for it.
            self._createRenderTask('onFirstConnected');
        }
        self.onConnected?.();
        self.$triggerEvent(self._tag + '-connected');
    }
    /** Event called when the CustomElement is adopted (moved from one DOM to another) */ adoptedCallback() {
        let self = this;
        // Make sure this will work with Firefox when moving elements between documents
        // INFO: https://jakearchibald.com/2025/firefox-custom-elements-iframes-bug/
        //rescueElementPrototype(self);
        self.$triggerEvent(self._tag + '-adopted');
        self.onAdopted?.();
    }
    /**
     * Event called when an observed attribute changes value
     * @param {string} name the name of the attribute
     * @param {string} oldValue the old value of the attribute
     * @param {string} newValue the new value of the attribute
     */ attributeChangedCallback(name, oldValue, newValue) {
        let self = this;
        if (oldValue === newValue || self._propChangeInProgress) return;
        // We have a backing field for all observed attributes
        let propName = self._attrToProps[name];
        let propFieldName = '$$prop$$' + (propName || '').toLowerCase();
        // Get the correct old value
        if (propFieldName in self) oldValue = self[propFieldName];
        // Get the 'correct' newValue based on it coming from .setAttribute or $setAttrib
        newValue = self._newAttribValue !== $b77b30c4d7cb9da3$var$emptyAttrib ? self._newAttribValue : self.$getValFromString(newValue);
        if (oldValue === newValue) return;
        self._createRenderTask('observedAttribChange');
        self.onAttributeChanged?.(name, oldValue, newValue);
        // Setting the property here will trigger an onPropertyChanged event which will
        // also make sure the _chPropOrAttrs array gets updated
        self._attribChangeInProgress = true;
        propName && (self[propName] = newValue);
        self._attribChangeInProgress = false;
    }
    /**
     * The render method, called each time the custom element needs to be updated/rendered
     * @param {string} renderReason the reason for the render beeing called
     * @returns {import("./types/lit-html").TemplateResult} the template to be rendered
     * */ render(renderReason) {
        return 0, $0585bced692c3b45$export$45b790e32b2810ee;
    }
    /** Destroys the element */ destroy() {
        let self = this;
        if (self._destroyed) return;
        self._destroyed = true;
        self.onDestroy?.();
        self._newAttribValue = null;
        self.options = null;
        self._obsAttrs.length = 0;
        self._obsAttrs = null;
        self._chPropOrAttrs.length = 0;
        self._chPropOrAttrs = null;
        self._obsProps.forEach((prop)=>{
            delete self['$$prop$$' + prop.toLowerCase()];
            delete self[prop];
        });
        self._obsProps.length = 0;
        self._obsProps = null;
        self._attrToProps = null;
        self._propToAttrs = null;
        self._css = null;
        self.$attribs = null;
        self.$attribsLC = null;
        self.parentElement?.removeChild(self);
        self.render = ()=>(0, $0585bced692c3b45$export$45b790e32b2810ee);
        self.$triggerEvent(self._tag + '-destroyed', {
            dispatch: false
        });
    }
    /**
     * Appends an eventlistener (this is a wrapper around addEventListener)
     * @param {string} eventName the event to react to
     * @param {EventListenerOrEventListenerObject} callback the event handler
     * @param {boolean|AddEventListenerOptions|undefined} [options] options
     * @returns {CustomHTMLElement}
     */ on(eventName, callback, options) {
        this.addEventListener(eventName, callback, options);
        return this;
    }
    /**
     * Removes an eventlistener (this is a wrapper around removeEventListener)
     * @param {string} eventName
     * @param {EventListenerOrEventListenerObject} callback
     * @param {boolean|AddEventListenerOptions|undefined} options
     * @returns {CustomHTMLElement}
     */ off(eventName, callback, options) {
        this.removeEventListener(eventName, callback, options);
        return this;
    }
    /**
     * Gets the value of an attribute. The value returned is the string converted value, which can be string, number, boolean, object, array, ...
     * @param {string} attr the attribute name
     * @returns {any} the attribute value
     */ $getAttrib(attr) {
        let self = this;
        // If the attribute is also a property where we use get/set then make sure we return
        // the 'real' value of the attribute, and not just the string representation (attributes are always strings).
        let propName = $b77b30c4d7cb9da3$var$camelize(attr);
        if (self._obsProps.indexOf(propName) !== -1) return self[propName];
        //        if (attr in self) {
        //window.console.log('$getAttrib', attr, '- in self')
        //            return self[attr];
        //        }
        return self.$getValFromString(self.getAttribute(attr));
    }
    /**
     * Sets an attribute value
     * @param {string} attr the attribute name
     * @param {any} val the value of the attribute
     */ $setAttrib(attr, val) {
        let self = this;
        let propName = '$$prop$$' + (self._attrToProps[attr] || '').toLowerCase();
        // If the attribute is also an observed attribute/property then make sure we keep
        // the 'real' value of the attribute, and not just the string representation (attributes are always strings).
        self._newAttribValue = propName in self ? val : $b77b30c4d7cb9da3$var$emptyAttrib;
        // NB! Calling set/remove-Attribute here triggers an attributeChangedCallback for
        //     observed attributes, which is the reason we set the _newAttribValue so that the
        //     callback can differentiate between internal set attributes and external.
        if (!val && val !== false) self.removeAttribute(attr);
        else $b77b30c4d7cb9da3$var$isObject(val) || $b77b30c4d7cb9da3$var$isArray(val) ? self.setAttribute(attr, JSON.stringify(val)) : self.setAttribute(attr, val);
        self._newAttribValue = $b77b30c4d7cb9da3$var$emptyAttrib;
        return self;
    }
    /**
     * Tries to convert a string to it's correct type
     * @param {string} val the string to be converted
     */ $getValFromString(val) {
        if (!val) return val;
        if (val[0] === '{') {
            if (val !== '{}' && val.indexOf(':') === -1) return val;
            return $b77b30c4d7cb9da3$var$tryParse(val) || val;
        }
        if (val[0] === '[') return $b77b30c4d7cb9da3$var$tryParse(val) || val;
        let number = parseFloat(val);
        if (!isNaN(number)) return number;
        return val === 'true' ? true : val === 'false' ? false : val === 'null' ? null : val === 'undefined' ? undefined : val;
    }
    /**
     * Sets the styling of the element
     * @param {string} css the css
     */ $setShadowStyle(css) {
        let self = this;
        // Need to make sure that the shadowRoot exists, which has happened when firstConnected is called
        if (!self._firstConnectedDone) {
            self._css = css;
            return self;
        }
        if (!self.shadowRoot) throw {
            message: 'Can only use $setShadowStyle on web component using shadowRoot'
        };
        css = css.replace('<style>', '').replace('</style>', '');
        // Use adoptedStyleSheets?
        //  INFO:
        //      https://github.com/lit/lit/blob/00b8c56422fc2577e265393cec6726a4e71a561f/packages/reactive-element/src/css-tag.ts#L99
        //      https://developer.mozilla.org/en-US/docs/Web/API/Document/adoptedStyleSheets
        //      https://web.dev/constructable-stylesheets/
        if ('adoptedStyleSheets' in Document.prototype && 'replace' in CSSStyleSheet.prototype) {
            let sheet = new CSSStyleSheet();
            sheet.replaceSync(css);
            self.shadowRoot.adoptedStyleSheets = [
                sheet
            ];
        } else {
            let style = document.createElement('style');
            style.textContent = css;
            self.shadowRoot.appendChild(style);
        }
        return self;
    }
}
// Firefox bug fix
// INFO:
//    https://jakearchibald.com/2025/firefox-custom-elements-iframes-bug/
//function rescueElementPrototype(element) {
//    // Return if everything looks as expected.
//    if (element instanceof CustomElementBase) {
//        return;
//    }
//
//    // Otherwise, get the intended constructor…
//    const constructor = customElements.get(element.tagName.toLowerCase());
//
//    // …and set the prototype.
//    Object.setPrototypeOf(element, constructor.prototype);
//}
class $b77b30c4d7cb9da3$var$CustomTokenHTMLElement extends $b77b30c4d7cb9da3$var$CustomHTMLElement {
    /**
     * Constructor
     */ constructor(DerivedClass, options){
        super(DerivedClass, options);
        let self = this;
        self._addReactiveProperty('userData');
        self._checkForUserInfoAndToken = self._checkForUserInfoAndToken.bind(self);
    }
    /**
     * Callback called when the custom element has been connected to the DOM for the first time
     * NB! Inherited Custom Elements *must* call super.onFirstConencted() if overriding this method
     */ onFirstConnected() {
        this._checkForUserInfoAndToken();
    }
    /**
     * Called when destroy has been called on the element, so we do some cleanup
     * NB! Inherited Custom Elements *must* call super.onDestroy() if overriding this method
     */ onDestroy() {
        let self = this;
        self._intervalTokenId && clearInterval(self._intervalTokenId);
        self._timeoutTokenId && clearTimeout(self._timeoutTokenId);
        self._intervalTokenId = null;
        self._timeoutTokenId = null;
    }
    /**
     * Make sure that we do not stop asking for userinfo and token until we get them. We do this
     * in case the user attaches an eventlistener for the 'needUserInfoAndToken' event after the
     * html element is attached to the DOM. The events bubble, so this can easily be avoided by
     * ex. attaching the eventlistener on the document (which will then automatically also work
     * for dynamically added elements)
     */ _checkForUserInfoAndToken() {
        let self = this;
        if (self.userData) return;
        if (self._checkedNoOfTimes > 50) return;
        self._checkedNoOfTimes = self._checkedNoOfTimes || 0;
        self._checkedNoOfTimes++;
        self.$triggerEvent('web-component-needUserInfoAndToken');
        setTimeout(self._checkForUserInfoAndToken, 25);
    }
    /**
     * Updated the userinfo and token
     */ updateUserInfoAndToken(tokenAndUserInfo) {
        let self = this;
        if (!tokenAndUserInfo.accessToken) {
            window['console'].log('Missing accesstoken');
            return;
        }
        if (tokenAndUserInfo.accessToken === self?.userData?.accessToken) //window['console'].log('Accesstoken not changed');
        return;
        let token = JSON.parse(window.atob(tokenAndUserInfo.accessToken.split('.')[1]));
        self._token = token;
        tokenAndUserInfo.identity = tokenAndUserInfo.userInfo;
        self.userData = tokenAndUserInfo;
        self.onUserData?.(self.userData);
        // Make sure we request a new updated token token when the current one is about to expire
        let now = parseInt(Date.now() / 1000);
        let timeoutInSec = token.exp - now - 10;
        //
        if (timeoutInSec <= 0) timeoutInSec = 1;
        self._intervalTokenId && clearInterval(self._intervalTokenId);
        self._timeoutTokenId && clearTimeout(self._timeoutTokenId);
        self._intervalTokenId = null;
        self._timeoutTokenId = setTimeout(()=>{
            self.$triggerEvent('web-component-needUserInfoAndToken');
            // Make sure we keep asking for userinfo and token until we get it. The interval
            // beeing called will stop once we get a valid new token
            self._intervalTokenId = setInterval(()=>{
                if (self._token.exp - parseInt(Date.now() / 1000) < 0) self.$triggerEvent('web-component-needUserInfoAndToken');
            }, 2000);
        }, timeoutInSec * 1000);
    }
}
/**
 * Parses a string template and converts it to a TemplateResult calling function, of which the
 * result can be used in the render function
 * @type {typeof import('./lithtmltypes').CreateTemplateFn}
 */ let $b77b30c4d7cb9da3$var$createTemplateFn = (strTemplate, options)=>{
    let { context: context, contextParams: contextParams, thisContext: thisContext } = options || {};
    let templateFn = new Function('lithtml', '$context', `
        let { ${(contextParams || []).join(',')} } = $context;
        let { nothing,noChange,html,svg,repeat,cache,choose,classMap,guard,ifDefined,join,keyed,live,map,range,ref,createRef,styleMap,until,when,asyncAppend,asyncReplace,templateContent,unsafeHTML,unsafeSVG,createTemplateFn,utils,virtualize,virtualizerRef } = lithtml;
        return html${'`' + strTemplate + '`'};`);
    if (thisContext) templateFn = templateFn.bind(thisContext);
    return (ctx)=>templateFn($b77b30c4d7cb9da3$var$lithtml, ctx || context || {});
};
/**
 * Takes a template string and optional context/data and renders the template to a DocumentFragment
 * @type {typeof import('./lithtmltypes').renderStrToEl}
 */ let $b77b30c4d7cb9da3$var$renderStrToEl = (strTemplate, options)=>{
    let htmlFn = $b77b30c4d7cb9da3$var$createTemplateFn(strTemplate, options);
    let target = new DocumentFragment();
    (0, $0585bced692c3b45$export$b3890eb0ae9dca99)(htmlFn(), target);
    return target;
};
/**
 * Takes a template string and optional context/data and renders the template to a string
 * @type {typeof import('./lithtmltypes').RenderStrToHtmlFn}
 */ let $b77b30c4d7cb9da3$var$renderStrToHtml = (strTemplate, options)=>{
    let fragment = $b77b30c4d7cb9da3$var$renderStrToEl(strTemplate, options);
    let tempEl = document.createElement('script');
    tempEl.type = 'text/html';
    tempEl.appendChild(fragment);
    return tempEl.innerHTML.trim().replaceAll(/\x3C![^>]*>/gi, '');
};
/**
 * Add translations recursively to the root of the translation object
 * @param {string} prefix the prefix added in fron of the translation keys (ex. '', 'Status.', ...)
 * @param {object} langObj the object containing the language translations
 * @param {object} translationObj the resulting translation object
 * @param {number} [index] optional index into the array of translations
 */ let $b77b30c4d7cb9da3$var$addLanguageRec = (prefix, langObj, translationObj, index = -1)=>{
    Object.keys(langObj).forEach((key)=>{
        let text = langObj[key];
        if ($b77b30c4d7cb9da3$var$isObject(text)) $b77b30c4d7cb9da3$var$addLanguageRec(prefix + key + '.', text, translationObj, index);
        else translationObj[prefix + key] = index === -1 ? text : text[index];
    });
};
/**
 * Initializes a new translations function
 * @param tagOrBaseTranslationUrl [string] the tag or the base url for language json files that may be downloaded
 * @param version [string=] the tag version
 */ let $b77b30c4d7cb9da3$var$translateInit = (tagOrBaseTranslationUrl, version)=>{
    let translations = Object.create(null);
    let currTranslation = defTranslation = translations;
    let translationBaseUrl;
    if (version) translationBaseUrl = `https://cdn.geminisuite.com/scripts/webcomponents/${tagOrBaseTranslationUrl}/${version}`;
    else if (tagOrBaseTranslationUrl) translationBaseUrl = tagOrBaseTranslationUrl;
    /** @type{import('./lithtmltypes').TranslateFunc} */ let t = (key)=>currTranslation[key] || defTranslation[key] || key;
    t.add = (lang, data)=>{
        let langName;
        if (typeof lang === 'string') {
            langName = lang;
            $b77b30c4d7cb9da3$var$addLanguageRec('', data, translations[lang] || (translations[lang] = Object.create(null)));
        } else if ($b77b30c4d7cb9da3$var$isArray(lang)) {
            langName = lang[0];
            lang.forEach((langName, index)=>$b77b30c4d7cb9da3$var$addLanguageRec('', data, translations[langName] || (translations[langName] = Object.create(null)), index));
        } else if ($b77b30c4d7cb9da3$var$isObject(lang)) {
            langName = Object.keys(lang)[0];
            Object.keys(lang).forEach((langName)=>$b77b30c4d7cb9da3$var$addLanguageRec('', lang[langName], translations[langName] = Object.create(null)));
        }
        // Set default language if not already done
        let globalLang = translations[$b77b30c4d7cb9da3$var$lithtml.translation.language];
        if (globalLang) {
            if (currTranslation === translations) currTranslation = globalLang;
            if (defTranslation === translations) defTranslation = globalLang;
        }
        // Make sure we do have a translation in case the global translation is missing
        if (currTranslation === translations) currTranslation = defTranslation = translations[langName];
        return t;
    };
    t.defTranslation = (langName)=>{
        let translationToUse = translations[langName];
        if (translationToUse) defTranslation = translationToUse;
        return t;
    };
    t.useLang = (langName)=>{
        let translationToUse = translations[langName];
        if (translationToUse) {
            currTranslation = translationToUse;
            if (defTranslation === translations) defTranslation = currTranslation;
        }
        return t;
    };
    t.load = (langName)=>{
        if (translations[langName]) {
            t.useLang(langName);
            return Promise.resolve();
        }
        if (!translationBaseUrl) return Promise.resolve();
        return fetch(`${translationBaseUrl}/${langName}.json`).then((response)=>{
            if (response.ok) return response.json();
        }).then((data)=>{
            if (data) t.add(langName, data).useLang(langName);
            return data;
        });
    };
    t.setTranslation = (langObj)=>{
        currTranslation = langObj;
        return t;
    };
    t.destroy = ()=>{
        translations = Object.create(null);
        currTranslation = null;
        defTranslation = null;
    };
    return t;
};
/** The global lithtml object */ let $b77b30c4d7cb9da3$var$lithtml = Object.create($b77b30c4d7cb9da3$var$events);
/** The current language */ let $b77b30c4d7cb9da3$var$currLanguage = (location.href.split('lang=')[1] || '').substring(0, 2);
if (!$b77b30c4d7cb9da3$var$currLanguage) $b77b30c4d7cb9da3$var$currLanguage = window.appContext?.language;
if (!$b77b30c4d7cb9da3$var$currLanguage) try {
    $b77b30c4d7cb9da3$var$currLanguage = localStorage.getItem('lang');
} catch (e) {}
if (!$b77b30c4d7cb9da3$var$currLanguage) $b77b30c4d7cb9da3$var$currLanguage = 'en';
$b77b30c4d7cb9da3$var$lithtml.render = (0, $0585bced692c3b45$export$b3890eb0ae9dca99);
$b77b30c4d7cb9da3$var$lithtml.nothing = (0, $0585bced692c3b45$export$45b790e32b2810ee);
$b77b30c4d7cb9da3$var$lithtml.noChange = (0, $0585bced692c3b45$export$9c068ae9cc5db4e8);
$b77b30c4d7cb9da3$var$lithtml.html = (0, $0585bced692c3b45$export$c0bb0b647f701bb5);
$b77b30c4d7cb9da3$var$lithtml.svg = (0, $0585bced692c3b45$export$7ed1367e7fa1ad68);
$b77b30c4d7cb9da3$var$lithtml.repeat = (0, $2d06e2ab5b695b60$export$76d90c956114f2c2);
$b77b30c4d7cb9da3$var$lithtml.cache = (0, $77f5167d06bc2fde$export$69a3209f1a06c04d);
$b77b30c4d7cb9da3$var$lithtml.choose = (0, $7b7b9a37160c97db$export$7877a478dd30fd3d);
$b77b30c4d7cb9da3$var$lithtml.classMap = (0, $e4437dd0216a4379$export$56cc687933817664);
$b77b30c4d7cb9da3$var$lithtml.guard = (0, $0100bfbf2c1b33f3$export$864d727b48066337);
$b77b30c4d7cb9da3$var$lithtml.ifDefined = (0, $49f9812d6d4b3bb6$export$f68dd208b5df064d);
$b77b30c4d7cb9da3$var$lithtml.join = (0, $0d7955f0662edf92$export$f7e2c8231c57a8bd);
$b77b30c4d7cb9da3$var$lithtml.keyed = (0, $ef64bd03c02e190d$export$8dbf9c790527241e);
$b77b30c4d7cb9da3$var$lithtml.live = (0, $2ed4c26e5fc1311e$export$28cf49ad70f82d12);
$b77b30c4d7cb9da3$var$lithtml.map = (0, $efb58c27b85b03fa$export$871de8747c9eaa88);
$b77b30c4d7cb9da3$var$lithtml.range = (0, $b0f47510656516d3$export$d02631cccf789723);
$b77b30c4d7cb9da3$var$lithtml.ref = (0, $65d76be7707749f6$export$eff4d24c3ff7876e);
$b77b30c4d7cb9da3$var$lithtml.createRef = (0, $65d76be7707749f6$export$7d1e3a5e95ceca43);
$b77b30c4d7cb9da3$var$lithtml.styleMap = (0, $22f699b0009eb85b$export$1e5b4ce2fa884e6a);
$b77b30c4d7cb9da3$var$lithtml.until = (0, $04babc6848c3c9b3$export$a40009bd2c363351);
$b77b30c4d7cb9da3$var$lithtml.when = (0, $d2deeaf9cd169c53$export$a55877ca9db47377);
$b77b30c4d7cb9da3$var$lithtml.asyncAppend = (0, $82e12a832c7dc237$export$eaa89ade56b7c0c1);
$b77b30c4d7cb9da3$var$lithtml.asyncReplace = (0, $9a7b48e7039d5564$export$662eef59ff6bd56a);
$b77b30c4d7cb9da3$var$lithtml.templateContent = (0, $9a609a3f11152775$export$e446d0492332fcd4);
$b77b30c4d7cb9da3$var$lithtml.unsafeHTML = (0, $0a9d83bb2173ec99$export$b6e69390c23686fb);
$b77b30c4d7cb9da3$var$lithtml.unsafeSVG = (0, $378ddd6808e465bc$export$1cb98903879b8bf5);
//lithtml.virtualize      = virtualize     ;
//lithtml.virtualizerRef  = virtualizerRef ;
$b77b30c4d7cb9da3$var$lithtml.CustomHTMLElement = $b77b30c4d7cb9da3$var$CustomHTMLElement;
$b77b30c4d7cb9da3$var$lithtml.CustomTokenHTMLElement = $b77b30c4d7cb9da3$var$CustomTokenHTMLElement;
$b77b30c4d7cb9da3$var$lithtml.utils = $f8f19630d13eb642$exports;
/**
 * preact signals
 * @type {import('./lithtmltypes').Signals}
 */ $b77b30c4d7cb9da3$var$lithtml.signals = {
    signal: $c9361041b5bd802c$export$e2ef10f86a8d60e8,
    batch: $c9361041b5bd802c$export$712ea50be43a7858,
    computed: $c9361041b5bd802c$export$2983e091f1a1e8e2,
    effect: $c9361041b5bd802c$export$dc573d8a6576cdb3,
    subscribe: (signalOrSignals, cb, { runOnSubscribe: runOnSubscribe, batchCallback: batchCallback } = {})=>{
        let signals = $b77b30c4d7cb9da3$var$isArray(signalOrSignals) ? signalOrSignals : [
            signalOrSignals
        ];
        let firstRun = true;
        let batching = false;
        return (0, $c9361041b5bd802c$export$dc573d8a6576cdb3)(()=>{
            signals.forEach((signal)=>signal.value);
            // Callback immediately after calling subscribe?
            if (firstRun) {
                firstRun = false;
                if (!runOnSubscribe) return;
            }
            // If no batching, run callback immediately on every signal change
            if (!batchCallback) {
                cb(signals);
                return;
            }
            if (batching) return;
            // TODO: call dispose here? and subscribe again in the resolved promise? maybe a problem with code that keeps track of the dispose function... --> could be solved with returning an object with dispose in? no need for 'batching' variable.
            batching = true;
            queueMicrotask(()=>{
                cb(signals);
                batching = false;
            });
        });
    }
};
/**
 * @type {import('./lithtmltypes').Translation}
 */ $b77b30c4d7cb9da3$var$lithtml.translation = {
    get language () {
        return $b77b30c4d7cb9da3$var$currLanguage;
    },
    init: $b77b30c4d7cb9da3$var$translateInit,
    useLang: (langName)=>{
        if (langName && $b77b30c4d7cb9da3$var$currLanguage !== langName) {
            $b77b30c4d7cb9da3$var$currLanguage = langName;
            $b77b30c4d7cb9da3$var$lithtml.emit('language-changed', {
                lang: $b77b30c4d7cb9da3$var$currLanguage
            });
        }
    }
};
let $b77b30c4d7cb9da3$var$stateObj = (0, $8e5676bd73916c78$export$52d98889efa7d412)(Object.create(null));
delete $b77b30c4d7cb9da3$var$stateObj.deEventify;
delete $b77b30c4d7cb9da3$var$stateObj.clearEvents;
$b77b30c4d7cb9da3$var$defineReadOnlyProperty($b77b30c4d7cb9da3$var$lithtml, 'state', Object.create($b77b30c4d7cb9da3$var$stateObj));
$b77b30c4d7cb9da3$var$lithtml.createTemplateFn = $b77b30c4d7cb9da3$var$createTemplateFn;
$b77b30c4d7cb9da3$var$lithtml.renderStrToHtml = $b77b30c4d7cb9da3$var$renderStrToHtml;
$b77b30c4d7cb9da3$var$lithtml.renderStrToEl = $b77b30c4d7cb9da3$var$renderStrToEl;
$b77b30c4d7cb9da3$var$lithtml.eventify = (0, $8e5676bd73916c78$export$52d98889efa7d412);
$b77b30c4d7cb9da3$var$lithtml.version = $b77b30c4d7cb9da3$var$version;
if (!window.lithtml || window.lithtml.version < $b77b30c4d7cb9da3$var$lithtml.version) window.lithtml = $b77b30c4d7cb9da3$var$lithtml;
 // Copy this for module min build
 //export const { render, nothing, noChange, html, svg, repeat, cache, choose, classMap, guard, ifDefined, join, keyed, live, map, range, ref, createRef, styleMap, until, when, asyncAppend, asyncReplace, templateContent, unsafeHTML, unsafeSVG, CustomHTMLElement, createTemplateFn, eventify, version, emitOnce, emitAsync, emit, once, off, on } = lithtml;
 // Use this for buildtest
 //export { render, nothing, noChange, html, svg, repeat, cache, choose, classMap, guard, ifDefined, join, keyed, live, map, range, ref, createRef, styleMap, until, when, asyncAppend, asyncReplace, templateContent, unsafeHTML, unsafeSVG, CustomHTMLElement };
 /*
    Example of generating dynamic html with lithtml

        let a = document.createElement('div');
        let b = lithtml.createTemplateFn('<b>test ${this.location.href}</b>', { thisContext: window });
        lithtml.render(b(), a);
        a.innerHTML;


        lithtml.render(lithtml.html`<b>testcccccc</b>`, document.body)



*/ 

})();
//# sourceMappingURL=lithtml.js.map
